import { Injectable } from '@angular/core';
import { MapConstants } from '../../../utils/map.constant';
import * as L from 'leaflet';
import 'leaflet.vectorgrid';
import 'src/assets/leaflet-velocity-src/js/L.CanvasLayer.js';
import * as R from 'leaflet-responsive-popup';
import { FloodForecastDataService } from './flood-forecast-data.service';
import { HttpClient } from '@angular/common/http';
import { isNullOrUndefined } from 'util';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { GisSvgService } from './flood-forecast-shared/gis-svg.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, Event, NavigationError } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FloodForecastUtilsService } from './flood-forecast-shared/floodForecastUtils.service';

import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { DateAdapter } from '@angular/material';
import { meta } from '@turf/turf';
@Injectable({
  providedIn: 'root'
})
export class FloodForecastMapService {

  graphData: any;
  stateBoundary: any;
  basinBoundary: any;
  highlightStationsArrGlobal: any;
  isActiveSpinner = new BehaviorSubject(false);
  isOpenDataTab = new BehaviorSubject(false);
  labelLayerList = {};
  previousLayer: any;
  reservoirData: any = {};
  riverGaugeData: any = {};
  shpBoundaryLayers: any = {};
  apwrimsAPIUrl: any;
  kaleshwaramWrisAPIUrl: any;
  apiUrl : any;
  kaleshwaramStagingUrl: any;
  regionSelected: string;
  tableData: any;
  navigationSubscription: any;
  urlParams: any;
  isPopUpOpen: any;
  resData : any;
  resCatchData : any;
  tnwrimsUrl = 'http://tnwrims-staging.vassarlabs.com/api/'
  kwrisURL = 'http://kfews-staging.vassarlabs.com/api/'
  odwrisURL = 'http://gowater-staging.vassarlabs.com/api/'
  riverNetworkLayerStyling: {};
  sourceDataAlert:any = 'RICKEN_NOWCAST';

  constructor(
    private floodDataService: FloodForecastDataService,
    private http: HttpClient,
    private gisSvgService: GisSvgService,
    private ffUtilsService: FloodForecastUtilsService,
    private router: Router,
    private utilsSrv:UtilsService,
    private route: ActivatedRoute,) {
    // this.apwrimsAPIUrl = ProjConstants.FORECAST_KALESHWARAM_API_URL;
    this.apwrimsAPIUrl = environment.url.APWRIMS_STAGING_API_URL;
    this.apiUrl = ProjConstants.API_URL
    this.kaleshwaramWrisAPIUrl = environment.url.temp2;
    this.kaleshwaramStagingUrl = environment.url.KALESHWARAM_API_URL;
    // this.apwrimsAPIUrl = ProjConstants.KALESHWARAM_API_URL;
    this.ffUtilsService.getFloodForecastSelectedRegion().subscribe(region => {
      if (region !== this.regionSelected) {
        this.regionSelected = region;
      }
    });
    this.navigationSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        this.urlParams = this.ffUtilsService.checkUrlParams(this.route.snapshot.params);
      }
      if (event instanceof NavigationError) {
        console.log(event.error); // Hide loading indicator  // Present error to user
      }
    });
  }

  changeLayersOnRegionChange(layersConfig, layersList, gis) {
    Object.keys(layersConfig).forEach(key => {
      if (layersConfig[key]['layerOptions']['visible'] && !layersList[key].wmsParams.visible) {
        // layersList[key].wmsParams.visible = !layersList[key].wmsParams.visible;
        layersList[key].setParams({ visible: true });
        gis.map.addLayer(layersList[key]);
      } else if (!layersConfig[key]['layerOptions']['visible'] && layersList[key].wmsParams.visible) {
        // layersList[key].wmsParams.visible = !layersList[key].wmsParams.visible;
        layersList[key].setParams({ visible: false });
        gis.map.removeLayer(layersList[key]);
      }
    });
    if (gis.regionSelected === 'godavariBasin' || gis.regionSelected === 'godavari_hec_hms') {
      if (!isNullOrUndefined(layersList['Godavari Label Markers'])) {
        if (!gis.map.hasLayer(layersList['Godavari Label Markers'])) {
          gis.map.addLayer(layersList['Godavari Label Markers']);
        }
      }
    } else {
      if (gis.map.hasLayer(layersList['Godavari Label Markers'])) {
        gis.map.removeLayer(layersList['Godavari Label Markers']);
      }
    }
  }

  validateValue(value: any) {
    if (!isNullOrUndefined(value) && value !== -1) {
      return true;
    }
    return false;
  }

  createBaseTileLayers(basLyrMetaData: any) {
    const layers = {};
    for (const key in basLyrMetaData) {
      if (basLyrMetaData.hasOwnProperty(key)) {
        const element = basLyrMetaData[key];
        layers[key] = new L.TileLayer(element.url, element.options);
      }
    }
    return layers;
  }

  setBaseLayer(baseTileLayers: any, gis: any) {
    for (const key in baseTileLayers) {
      if (baseTileLayers.hasOwnProperty(key)) {
        const element = baseTileLayers[key];
        if (element.options.visible === true) {
          element.addTo(gis.map);
        }
      }
    }
  }

  getApplicationBasedLayer(type: string, metaData: any, compType?: any) {
    const layersList = metaData.FloodForecastCommonLayers;
    if (type === 'WMS' && compType === 'inundation') {
      return this.formatWMSLayers(metaData.InundationCommonLayers, compType);
    } else if (type === 'WMS') {
      return this.formatWMSLayers(layersList);
    } else if (type === 'VECTOR') {
      return this.formatVECTORLayers(layersList);
    } else if (type === 'GEOJSON') {
      return this.formatGeoJSONLayers(layersList);
    }
  }

  formatWMSLayers(data, compType?: any) {    // need to change logic here for Layers To Add
    const overlays = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        const overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'wms';
        overlay.layerOptions = {};
        overlay.layerOptions.name = value.name;
        overlay.layerOptions.format = 'image/png';
        overlay.layerOptions.transparent = true;
        if (compType) {
          overlay.url = this.getInundationCompGeoServerURL() + '/wms';
        } else if (overlay.name === 'State Boundary') {
          overlay.url = ProjConstants.GEOSERVER_URL+'new-geoserver/forecast/wms';
        }
        else if (overlay.name === 'Tamilnadu Basin') {
          overlay.url = ProjConstants.TNGEOSERVER_URL+'geoserver/tamilnadu/wms';
        }
        else if (overlay.name === 'Kerala Basin') {
          overlay.url = ProjConstants.KLGEOSERVER_URL+'new-geoserver/ows/wms';
        }
        else if (overlay.name === 'Odisha State') {
          overlay.url = ProjConstants.ODGEOSERVER_URL+'geoserver/odisha/ows/wms';
        }
        else if (value.forecastUrl) {
          overlay.url = this.getGeoServerForecastWMSURL();
        } else {
          overlay.url = this.getGeoServerURL() + '/wms';
        }
        if (this.validateValue(value.legendData)) {
          overlay.layerOptions.legendData = value.legendData;
        }
        if (this.validateValue(value.cql_filter)) {
          overlay.layerOptions.cql_filter = value.cql_filter;
        }
        if (this.validateValue(value.subgroup)) {
          overlay.layerOptions.subgroup = value.subgroup;
        }
        if (this.validateValue(value.visible)) {
          overlay.layerOptions.visible = value.visible;
        }
        if (this.validateValue(value.group)) {
          overlay.layerOptions.group = value.group;
        }
        if (this.validateValue(value.layeroptions_name)) {
          overlay.layerOptions.layers = value.layeroptions_name;
        }
        if (this.validateValue(value.layeroptions_min_zoom)) {
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        }
        if (this.validateValue(value.layeroptions_max_zoom)) {
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        }
        if (this.validateValue(value.layeroptions_pane)) {
          overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_zindex)) {
          overlay.layerOptions.zIndex = value.layeroptions_zindex;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector) {
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        }
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type;
        }
        if (this.validateValue(value.data)) {
          overlay.layerOptions.data = value.data;
        }
        if (this.validateValue(value.crs) && value.crs === 'EPSG4326') {
          overlay.layerOptions.crs = L.CRS.EPSG4326;
        }
        if (this.validateValue(value.position)) {
          overlay.layerOptions.position = value.position;
        }
        if (value.type === 'WMS') {
          overlay.key = key;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.layeroptions_styles)) {
          overlay.layerOptions.STYLES = value.layeroptions_styles;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info;
        }
      }
    }
    return overlays;
  }

  setWmsTileLayers(wmsTileLayers, gis) {
    // console.log(allLayers);
    const layers = {};
    for (const key in wmsTileLayers) {
      if (wmsTileLayers.hasOwnProperty(key)) {
        const layer = wmsTileLayers[key];
        // if(specific_layer){
        //   if(specific_layer === layer.layerOptions.name){
        //     let wmslayer = new L.tileLayer.wms(layer.url,layer.layerOptions);
        //     layers[key] = wmslayer;
        //     // if(layer.layerOptions.visible === true)
        //     wmslayer.addTo(mapObject)
        //   }
        // }else{
        const wmslayer = new (L as any).TileLayer.WMS(layer.url, layer.layerOptions);
        layers[key] = wmslayer;
        if (layer.layerOptions.visible === true) {
          wmslayer.addTo(gis.map);
        }
      }
    }
    return layers;
  }

  formatVECTORLayers(data) {
    const overlays: any = {};
    // data.forEach(element => {
    for (const key in data) {
      if (key) {
        const element = data[key];
        if (element.type === 'VECTOR') {
          const overlay: any = {};
          overlay.type = 'vector';
          overlay.name = element.name;
          overlay.layerOptions = {};
          // overlay.layerOptions.interactive = true;
          overlay.layerOptions.interactive = false;
          overlay.layerOptions.rendererFactory = (L as any).canvas.tile;
          overlay.url = element.url;
          if (this.validateValue(element.cql_filter)) {
            overlay.layerOptions.cql_filter = element.cql_filter;
          }
          overlay.layerOptions.pane = element.layeroptions_pane;
          overlay.layerOptions.minZoom = element.layeroptions_min_zoom;
          overlay.layerOptions.maxZoom = element.layeroptions_max_zoom;
          overlay.layerOptions.visible = element.visible;
          overlay.layerOptions.group = element.group;
          if (this.validateValue(element.layeroptions_show_on_selector) && !element.layeroptions_show_on_selector) {
            overlay.layerOptions.showOnSelector = element.layeroptions_show_on_selector;
          }
          if (this.validateValue(element.group_type)) {
            overlay.layerOptions.groupType = element.group_type;
          }
          overlay.layerOptions.vectorTileLayerStyles = {};

          if (element.layer_name === 'STATE') {
            overlay.layerOptions.vectorTileLayerStyles['kwaram_telangana_district'] = {
              fillColor: 'transparent',
              opacity: 1,
              weight: 0.25,
              color: '#000000'
            };
            overlay.layerOptions.getFeatureId = (feature) => {
              return feature.properties.gid;
            };
          } else if (element.layer_name === 'DISTRICT') {
            overlay.layerOptions.vectorTileLayerStyles['kwaram_ts_mandal'] = {
              opacity: 0.5,
              weight: 0.15,
              color: '#000000'
            };
            overlay.layerOptions.getFeatureId = (feature) => {
              return feature.properties.gid;
            };
          } else if (element.layer_name === 'CATCHMENT_FULL') {
            overlay.layerOptions.vectorTileLayerStyles['FLOODFORECAST_CATCHMENTS'] = () => {
              const style = {
                opacity: 0
              };
              return style;
            };
            overlay.layerOptions.getFeatureId = (feature) => {
              return feature.properties.uuid;
            };
          } else if (element.layer_name === 'CATCHMENT_INDI') {
            overlay.layerOptions.vectorTileLayerStyles['FLOODFORECAST_CATCHMENTS_INDIVIDUAL'] = () => {
              const style = {
                opacity: 0
              };
              return style;
            };
            overlay.layerOptions.getFeatureId = (feature) => {
              return feature.properties.uuid;
            };
          }
          if (element.type === 'VECTOR') {
            overlay.key = element;
            overlays[key] = overlay;
          }
        }
      }
    }
    return overlays;
  }

  setVectorOverlays(vectorLayersConfig, gis) {
    const layers: any = {};
    for (const key in vectorLayersConfig) {
      if (vectorLayersConfig.hasOwnProperty(key)) {
        const layer = vectorLayersConfig[key];
        const vectorLayer = new (L as any).vectorGrid.protobuf(layer.url, layer.layerOptions);
        layers[key] = vectorLayer;

        if (layer.layerOptions.visible == true) {
          gis.map.addLayer(layers[key]);
        }
      }
    }
    return layers;
  }

  formatGeoJSONLayers(data) {
    const overlays: any = {};
    // data.forEach(element => {
    for (const key in data) {
      if (key) {
        const element = data[key];
        if (element.type === 'GEOJSON') {
          const overlay: any = {};
          overlay.type = 'geoJSON';
          overlay.name = element.name;
          overlay.layerOptions = {};
          // overlay.layerOptions.interactive = true;
          overlay.layerOptions.interactive = false;
          overlay.data = {};
          overlay.layerOptions.pane = element.layeroptions_pane;
          overlay.layerOptions.minZoom = element.layeroptions_min_zoom;
          overlay.layerOptions.maxZoom = element.layeroptions_max_zoom;
          overlay.layerOptions.visible = element.visible;
          overlay.layerOptions.group = element.group;
          if (this.validateValue(element.layeroptions_show_on_selector) && !element.layeroptions_show_on_selector) {
            overlay.layerOptions.showOnSelector = element.layeroptions_show_on_selector;
          }
          if (this.validateValue(element.group_type)) {
            overlay.layerOptions.groupType = element.group_type;
          }
          overlay.layerOptions.style = this.stylingforGeoJson();
          if (element.type === 'GEOJSON') {
            overlay.key = element;
            overlays[key] = overlay;
          }
        }
      }
    }
    return overlays;
  }

  setGeoJSONOverlays(geoJsonLayersConfig, gis) {
    const geoJsonObject = [{
      type: 'LineString',
      coordinates: [[-100, 99], [-100, 99.1]]
    }];
    const layers: any = {};
    for (const key in geoJsonLayersConfig) {
      if (geoJsonLayersConfig.hasOwnProperty(key)) {
        const layer = geoJsonLayersConfig[key];
        const geoJsonLayer = new (L as any).geoJSON(geoJsonObject, layer.layerOptions);
        layers[key] = geoJsonLayer;

        if (layer.layerOptions.visible === true) {
          gis.map.addLayer(layers[key]);
        }
      }
    }
    return layers
  }

  // getGeoJSONData(layer, options) {
  //   // https://forecast.vassarlabs.com/klswgeo/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:flood_forecast_river_links_v8_20210524&maxFeatures=5000000&outputFormat=application%2Fjson
  //   let layerURL = "https://forecast.vassarlabs.com/klswgeo/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:" + layer + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
  //   // let layerURL = "http://localhost:8080/geoserver/cite/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=cite:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
  //   if (options.filter) {
  //     layerURL += '&cql_filter=' + options.filter;
  //   }
  //   return this.http.get<any>(layerURL);
  // }

  getGeoJSONData(layer, options) {

    let layerURL = this.getGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let layerURL = "http://159.65.4.230/geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:" + layer + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    // let layerURL = "http://localhost:8080/geoserver/cite/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=cite:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    if (options.filter) {
      layerURL += '&cql_filter=' + options.filter;
    }
    return this.http.get<any>(layerURL);
  }
  getGeoJSONData2(layer, options) {

    let layerURL = this.getTNGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let layerURL = "http://159.65.4.230/geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:" + layer + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    // let layerURL = "http://localhost:8080/geoserver/cite/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=cite:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    if (options.filter) {
      layerURL += '&cql_filter=' + options.filter;
    }
    return this.http.get<any>(layerURL);
  }
  getGeoJSONDataKW(layer, options) {

    let layerURL = this.getKWGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let layerURL = "http://159.65.4.230/geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:" + layer + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    // let layerURL = "http://localhost:8080/geoserver/cite/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=cite:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    if (options.filter) {
      layerURL += '&cql_filter=' + options.filter;
    }
    return this.http.get<any>(layerURL);
  }
  getGeoJSONDataOD(layer, options) {




    let layerURL = this.getODGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let layerURL = "http://159.65.4.230/geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=kaleshwaram:" + layer + "&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    // let layerURL = "http://localhost:8080/geoserver/cite/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=cite:"+layerName+"&maxFeatures=5000000&outputFormat=application%2Fjson" as string;
    if (options.filter) {
      layerURL += '&cql_filter=' + options.filter;
    }
    return this.http.get<any>(layerURL);
  }

  getKlwseoServerURL() {
    const url = environment.url.KLWSGEOSERVER_URL + 'ows';
    return url;
  }

  getstartandEndForNday(nday) {
    let startDate, endDate;
    const startandEndList = [];
    const currentDate = new Date();
    const currentTs = new Date().setHours(0, 0, 0, 0);
    const rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    if (currentDate.getTime() >= rfStartofDay) {
      endDate = moment().format('YYYYMMDD');
      startDate = moment().subtract(nday - 1, 'days').format('YYYYMMDD');
    } else {
      endDate = moment().subtract(1, 'days').format('YYYYMMDD');
      startDate = moment().subtract(nday, 'days').format('YYYYMMDD');
    }
    startandEndList[0] = startDate;
    startandEndList[1] = endDate;
    return startandEndList;
  }

  drawFloodForecastPoints(geoJson, flowType, gis, metaData, modalSrv, urlParams, labelData, stateUUID, regionSelected) {

    const metaDataResult = metaData;
    if (!geoJson) {
      return;
    }

    const promise = new Promise((resolve, reject) => {
      let geoJsonLayer, temp = 1;
      if (!this.highlightStationsArrGlobal) {
        // console.log("ENtered If.........");
        let sourceAlert: any;
        this.utilsSrv.getSourceAlert().subscribe((data => {
          // console.log(data,"data@@");

          if (data == "Ricken") {
            sourceAlert = "RICKEN_NOWCAST"
          }
          else if (data == "Radar") {
            sourceAlert = "SIMPLE_RADAR_NOWCAST"
          }
          else if (data == "IMD Radar" || !data) {
            sourceAlert = "IMD_RADAR_NOWCAST"
          }
          else if (data == "Radar+ CTT") {
            sourceAlert = "RADAR_CTT_EUMETSAT_NOWCAST"
          }
          this.getResPointData(sourceAlert).subscribe((response) => {
            let data = response
            this.resData = data

            this.getRainfallCatchmentData(sourceAlert).subscribe((response) => {    // for Rainfall catchment data
              // console.log(response,"response");
              this.resCatchData = response


              this.getreservoirData().subscribe((response) => {
                for (const key in response) {
                  const reservoirName = this.gisSvgService.getWaterSourceNameFromUUID(key, 'RESERVOIR');    //for map timeSeries of reservoir
                  if (!isNullOrUndefined(reservoirName)) {
                    this.reservoirData[reservoirName.toLowerCase()] = response[key];
                  }
                }

                // this.getBasinPreviousDayTableData().subscribe(tableData => {
                //   this.tableData = tableData;
                this.getriverGagugeData().subscribe((response) => {
                  this.getreservoirData().subscribe(storageData => {
                    // console.log("storageData",storageData);

                    for (const key in response) {
                      const rivergaugeName = this.gisSvgService.getWaterSourceNameFromUUID(key, 'RIVERGAUGE');
                      this.riverGaugeData[rivergaugeName] = response[key];
                    }
                    geoJsonLayer = L.geoJSON(geoJson, {
                      pointToLayer: (feature, latlng) => {
                        const marker = this.createMarker(latlng, feature.properties, gis, metaDataResult, modalSrv, urlParams, feature, stateUUID, storageData, this.resData, this.resCatchData);
                        // Need to Reimplement this way of plotting labels
                        // this.labellingNameOnZoom(metaDataResult, map, feature, latlng, tableData,labelData)
                        return marker;
                      }
                    });
                    resolve(geoJsonLayer);
                  });
                })
                this.addZoomLabels(geoJson, gis.map, labelData);

                // });
              }, function (error) {
                console.log('Error');
              });
            });
          });
        })
        )
      } else {
        this.getreservoirData().subscribe((response) => {
          for (const key in response) {
            const reservoirName = this.gisSvgService.getWaterSourceNameFromUUID(key, 'RESERVOIR');
            if (!isNullOrUndefined(reservoirName)) {
              this.reservoirData[reservoirName.toLowerCase()] = response[key];
            }
          }

          this.getBasinPreviousDayTableData().subscribe(tableData => {
            this.tableData = tableData;
            this.getriverGagugeData().subscribe((response) => {
              for (const key in response) {
                const rivergaugeName = this.gisSvgService.getWaterSourceNameFromUUID(key, 'RIVERGAUGE');
                this.riverGaugeData[rivergaugeName] = response[key];
              }
              geoJsonLayer = L.geoJSON(geoJson, {
                pointToLayer: (feature, latlng) => {
                  const marker = this.createMarker(latlng, feature.properties, gis, metaDataResult, modalSrv, urlParams, feature, stateUUID,this.resData,this.resCatchData);
                  // Need to Reimplement this way of plotting labels
                  // this.labellingNameOnZoom(metaDataResult, map, feature, latlng, tableData, labelData)
                  return marker;
                }
              });
              resolve(geoJsonLayer);
            });
            this.addZoomLabels(geoJson, gis.map, labelData);

          });
        });
      }
    });


    return promise;
  }

  addZoomLabels(geoJson, map, labelData) {
    if (!this.tableData) {
      return;
    }

    const last5DayTableData = this.tableData != null ? this.tableData : null;
    for (const index in geoJson.features) {
      const feature = geoJson.features[index];
      if (!feature || !feature.geometry) { continue; }
      const latlng = new L.latLng(feature.geometry.coordinates);
      const pointTableData = last5DayTableData != null ? (last5DayTableData.computedData[feature['properties'].point_name] ? last5DayTableData.computedData[feature.properties.point_name] : null) : null;

      let currentZoom, currentStorage, currentCapacity, labelPointNames, pointName, gps, htmlLabel, bydefaultLabel, bydefaultmarker, inflow, outflow, labelName;
      labelPointNames = labelData.zoomToLabelMap[map.getZoom()];

      pointName = feature['properties'].point_name;

      if (labelPointNames != null && labelPointNames.includes(pointName)) {
        currentZoom = map.getZoom();
        gps = labelData.pointGPSMap[pointName] ?
          (labelData.pointGPSMap[pointName].gps[currentZoom] ? labelData.pointGPSMap[pointName].gps[currentZoom] : latlng) : latlng;
        labelName = labelData.pointGPSMap[pointName] ? labelData.pointGPSMap[pointName].name : pointName;
        if (pointName.includes('FFS')) {
          htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
        } else {
          if (pointTableData != null) {
            const key = Object.keys(pointTableData)[0];
            currentStorage = pointTableData[key].stg != null ? pointTableData[key].stg.toFixed(2) : null;
            currentCapacity = pointTableData[key].dex != null ? (pointTableData[key].dex.designcapacity != null ? parseFloat(pointTableData[key].dex.designcapacity).toFixed(2) : null) : null;
          }
          htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
          if (!isNullOrUndefined(currentStorage) && !isNullOrUndefined(currentCapacity)) { htmlLabel += '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + currentStorage + ' / ' + currentCapacity + '</div>'; }

        }
        bydefaultLabel = L.divIcon({ className: 'my-div-icon', html: htmlLabel });
        bydefaultmarker = L.marker(gps, {
          pane: 'group2',
          icon: bydefaultLabel
        }
        );
        // layerList.push(bydefaultmarker)
        this.labelLayerList[pointName] = bydefaultmarker;
        bydefaultmarker.addTo(map);
      }
    }

  }

  getHighlightStationsData(data) {
    let graphDataAll = data.computedData, countOuter = 0, countInner = 0, countPriority = 0;
    const highlightStationsArr = {};

    for (const keyOuter in graphDataAll) {
      if (graphDataAll.hasOwnProperty(keyOuter)) {
        countOuter += 1;
        const dataForChart = [];
        const sortableIn = [];
        const sortableOf = [];
        let danger_level_flow = [];
        let highest_flood_level_flow = [];
        let warning_level_flow = [];
        const pointName = keyOuter;
        this.graphData = data.computedData[pointName];
        for (const key in this.graphData) {
          if (this.graphData.hasOwnProperty(key)) {
            const value = this.graphData[key];
            const day = this.floodDataService.getDateandTimeDashSeparatorNew(Number(key));

            if (value.in != null && value.in < 2000000) {
              sortableIn.push([day, parseFloat(value.in.toFixed(2))]);
            } else {
              sortableIn.push([day, null]);
            }
            if (value.dsof != null) {
              sortableOf.push([day, parseFloat(value.dsof.toFixed(2))]);
            } else {
              sortableOf.push([day, null]);
            }
            if (value.dex != null) {

              if (value.dex.danger_level_flow != null && parseFloat(value.dex.danger_level_flow) > 0) {
                const dlf = parseFloat(value.dex.danger_level_flow);
                danger_level_flow.push([day, parseFloat(dlf.toFixed(2))]);
              }
              if (value.dex.highest_flood_level_flow != null && parseFloat(value.dex.highest_flood_level_flow) > 0) {
                const hfl = parseFloat(value.dex.highest_flood_level_flow);
                highest_flood_level_flow.push([day, parseFloat(hfl.toFixed(2))]);
              }

              if (value.dex.warning_level_flow != null && parseFloat(value.dex.warning_level_flow) > 0) {
                const wlf = parseFloat(value.dex.warning_level_flow);
                warning_level_flow.push([day, parseFloat(wlf.toFixed(2))]);
              }
            }

          }
        }
        let obj: any = {};
        if (sortableIn.length > 0) {
          obj = {};
          obj.data = sortableIn.sort();
          obj.name = 'Inflow';
          obj.color = '#6CF';
          obj.yAxis = 0;
          obj.lineWidth = 2;
          obj.marker = { enabled: true, symbol: 'circle', radius: 2 };
          dataForChart.push(obj);
        }
        if (sortableOf.length > 0) {
          obj = {};
          obj.data = sortableOf.sort();
          obj.name = 'Outflow';
          obj.color = '#39F';
          obj.yAxis = 0;
          obj.lineWidth = 2;
          obj.marker = { enabled: true, symbol: 'circle', radius: 2 };
          dataForChart.push(obj);
        }

        if (warning_level_flow.length > 0) {
          obj = {};
          obj.data = warning_level_flow.sort();
          obj.name = 'Warning Level';
          obj.color = '#ffa500';
          obj.yAxis = 0;
          obj.lineWidth = 2;
          obj.marker = { enabled: false, symbol: 'circle', radius: 2 };
          dataForChart.push(obj);
        }

        if (danger_level_flow.length > 0) {
          obj = {};
          obj.data = danger_level_flow.sort();
          obj.name = 'Danger Level';
          obj.color = '#d17402';
          obj.yAxis = 0;
          obj.lineWidth = 2;
          obj.marker = { enabled: false, symbol: 'circle', radius: 2 };
          dataForChart.push(obj);
        }

        if (highest_flood_level_flow.length > 0) {
          obj = {};
          obj.data = highest_flood_level_flow.sort();
          obj.name = 'Highest Flood Level';
          obj.color = '#9c3802';
          obj.yAxis = 0;
          obj.lineWidth = 2;
          obj.marker = { enabled: false, symbol: 'circle', radius: 2 };
          dataForChart.push(obj);
        }
        let maxFlow, maxWarningLevel = [], maxDangerLevel = [], maxFloodLevel = [];
        let maxMinarr = [];
        if (dataForChart && dataForChart.length > 1) {
          countInner += 1;
          for (let index = 0; index < dataForChart.length; index++) {
            maxMinarr = this.getMaxMin(dataForChart[index]['data']);
            if (dataForChart[index]['name'] == 'Inflow' || dataForChart[index]['name'] == 'Outflow') {
              if (!maxFlow && maxMinarr[0]) {
                maxFlow = maxMinarr[0];
              } else if (!maxFlow || maxMinarr[0] > maxFlow) {
                maxFlow = maxMinarr[0];
              }
            } else if (dataForChart[index]['name'] == 'Warning Level') {
              if (maxMinarr[0]) {
                maxWarningLevel[0] = maxMinarr[0];
                maxWarningLevel[1] = '#ffa500';
              }
            } else if (dataForChart[index]['name'] == 'Danger Level') {
              if (maxMinarr[0]) {
                maxDangerLevel[0] = maxMinarr[0];
                maxDangerLevel[1] = '#d17402';
              }
            } else if (dataForChart[index]['name'] == 'Highest Flood Level') {
              if (maxMinarr[0]) {
                maxFloodLevel[0] = maxMinarr[0];
                maxFloodLevel[1] = '#9c3802';
              }
            }
          }
        }
        let color = '';
        if (maxFlow && (maxDangerLevel || maxFloodLevel || maxWarningLevel)) {
          if (maxFlow > maxDangerLevel[0]) {
            if (maxFlow > maxFloodLevel[0]) {
              color = maxFloodLevel[1];
            } else {
              color = maxDangerLevel[1];
            }
          } else if (maxFlow > maxWarningLevel[0]) {
            color = maxWarningLevel[1];
          }
        }
        if (color) {
          countPriority += 1;
          const tempObj = {};
          tempObj[keyOuter] = color;
          highlightStationsArr[keyOuter] = color;
        }
      }
    }
    return highlightStationsArr;
  }

  getMaxMin(arr) {
    let max = -10, min = 10000000;
    for (let index = 0; index < arr.length; index++) {
      if (arr[index][1] && (min > arr[index][1])) {
        min = arr[index][1];
      }
      if (arr[index][1] && (max < arr[index][1])) {
        max = arr[index][1];
      }
    }
    return ([max, min]);
  }

  labellingNameOnZoom(metaDataResult, map, feature, latlng, tableData, labelData) {
    // let layerList=[]
    const last5DayTableData = tableData != null ? tableData : null;
    const pointTableData = last5DayTableData != null ? (last5DayTableData.computedData[feature.properties.point_name] ? last5DayTableData.computedData[feature.properties.point_name] : null) : null;

    let currentZoom, currentStorage, currentCapacity, labelPointNames, pointName, gps, htmlLabel, bydefaultLabel, bydefaultmarker, inflow, outflow, labelName;
    labelPointNames = labelData.zoomToLabelMap[map.getZoom()];
    pointName = feature.properties.point_name;

    if (labelPointNames != null && labelPointNames.includes(pointName)) {
      currentZoom = map.getZoom();
      gps = labelData.pointGPSMap[pointName] ?
        (labelData.pointGPSMap[pointName].gps[currentZoom] ? labelData.pointGPSMap[pointName].gps[currentZoom] : latlng) : latlng;
      labelName = labelData.pointGPSMap[pointName] ? labelData.pointGPSMap[pointName].name : pointName;
      if (pointName.includes('FFS')) {
        htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
      } else {
        if (pointTableData != null) {
          const key = Object.keys(pointTableData)[0];
          currentStorage = pointTableData[key].stg != null ? pointTableData[key].stg.toFixed(2) : null;
          currentCapacity = pointTableData[key].dex != null ? (pointTableData[key].dex.designcapacity != null ? parseFloat(pointTableData[key].dex.designcapacity).toFixed(2) : null) : null;
        }
        htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
        if (!isNullOrUndefined(currentStorage) && !isNullOrUndefined(currentCapacity)) { htmlLabel += '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + currentStorage + ' / ' + currentCapacity + '</div>'; }

      }
      bydefaultLabel = L.divIcon({ className: 'my-div-icon', html: htmlLabel });
      bydefaultmarker = L.marker(gps, {
        pane: 'group2',
        icon: bydefaultLabel
      }
      );
      // layerList.push(bydefaultmarker)
      // this.labelLayerList.push(bydefaultmarker);
      bydefaultmarker.addTo(map);
    }

    map.on({
      zoomend: (e: L.LeafletEvent) => {

        //  for(var i=0;i<layerList.length;i++){
        if (map.hasLayer(bydefaultmarker)) {
          map.removeLayer(bydefaultmarker);
        }
        //  }
        currentZoom = map.getZoom();
        labelPointNames = labelData.zoomToLabelMap[currentZoom];
        pointName = feature.properties.point_name;
        inflow = metaDataResult[pointName] ? metaDataResult[pointName].cst : '-';
        outflow = metaDataResult[pointName] ? metaDataResult[pointName].dn : '-';
        if (labelPointNames != null && labelPointNames.includes(pointName)) {

          gps = labelData.pointGPSMap[pointName] ?
            (labelData.pointGPSMap[pointName].gps[currentZoom] ? labelData.pointGPSMap[pointName].gps[currentZoom] : latlng) : latlng;
          labelName = labelData.pointGPSMap[pointName] ? labelData.pointGPSMap[pointName].name : pointName;
          if (pointName.includes('FFS')) {

            htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
          } else {

            if (pointTableData != null) {
              const key = Object.keys(pointTableData) ? Object.keys(pointTableData)[0] : null;
              if (!isNullOrUndefined(key)) {
                currentStorage = pointTableData[key].stg != null ? pointTableData[key].stg.toFixed(2) : null;
                currentCapacity = pointTableData[key].dex != null ? (pointTableData[key].dex.designcapacity != null ? parseFloat(pointTableData[key].dex.designcapacity).toFixed(2) : null) : null;
              } else {
                currentStorage = null;
                currentCapacity = null;
              }
            }
            htmlLabel = '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + labelName + '</div>';
            if (!isNullOrUndefined(currentStorage) && !isNullOrUndefined(currentCapacity)) { htmlLabel += '<div style=\'font-size:' + map.getZoom() * 1.4 + 'px;color:#663300;width:100px\'>' + currentStorage + ' / ' + currentCapacity + '</div>'; }

          }
          bydefaultLabel = L.divIcon({ className: 'my-div-icon', html: htmlLabel });
          bydefaultmarker = L.marker(gps, {
            pane: 'group2',
            icon: bydefaultLabel
          }
          );
          //  layerList.push(bydefaultmarker)
          // this.labelLayerList.push(bydefaultmarker);
          bydefaultmarker.addTo(map);
        }

      }
    });

  }

  public checkUrlParams(obj: object): object {
    const objectConfig = {};

    if (obj == null || obj == undefined) { return obj; }

    for (const key in obj) {
      objectConfig[key] = obj[key];
    }

    return objectConfig;
  }

  processLegendDate(startTs, endTs) {
    return new Promise((resolve, reject) => {
      this.getRainfallLegendData(startTs, endTs).subscribe(data => {
        resolve(data);
      });

    });
  }

  getRainfallLegendData(startTs, endTs) {
    const FLOW_URL = this.kaleshwaramStagingUrl + 'kaleshwaram/getLegendDataForComponent/RAINFALL/NONE/' + startTs + '/' + endTs;
    // console.log(FLOW_URL);
    return this.http.get<any>(FLOW_URL);
  }

  //method to convert array of string to array of number
  convertStringToNumber(array) {
    return array.map(function (item) {
      return parseFloat(item);
    });
  }

  createMarker(latLng, arData, gis, metaDataResult, modalSrv, urlParams, feature, stateUUID,storageData?,resData? ,resCatch?) {
    // console.log("CON1",arData)
    if (feature.properties.point_name == 'Sir Aurthur Cotton Barrage' && urlParams.srcType != 'godavari_hec_hms'&&feature.properties.basin != 'Periyar' && feature.properties.basin !='Chalakudy') {  //for temporary purpose
      feature.properties.point_name = 'SIR AURTHUR COTTON BARRAGE';
    }
    if (feature.properties.point_name == null && urlParams.srcType != 'godavari_hec_hms' && feature.properties.basin != 'Periyar' && feature.properties.basin !='Chalakudy'  &&feature.properties.basin != 'PERIYAR' ) {
       //for temporary purpose   Here Conditions
      feature.properties.point_name = (feature.properties.point_na_1).toUpperCase();
    }
    if(feature.properties.basin == 'Periyar' || feature.properties.basin =='Chalakudy' ){
      feature.properties.point_name = (feature.properties.system_res)
      feature.properties.point_na_1 = feature.properties.system_res
      feature.properties.state = 'Kerala'
    }


    let alert : any
    if(metaDataResult[feature.properties.point_name]){
      //getting todaysStorage & capacity & fillPercentage
      if(resData && resData[metaDataResult[feature.properties.point_name].uuid]){
        alert = resData[metaDataResult[feature.properties.point_name].uuid].status
      }

      let point_name = arData['point_na_1'];
      arData['uuid']=arData['location_u']
      // console.log("map.getZoom().............",map.getZoom(), getMarkerRadius2(map.getZoom(),2), (getMarkerRadius2(map.getZoom(),2)+4));
      const geojsonMarkerOptions = {
        radius: this.getMarkerRadius(gis.map.getZoom()),
        fillColor: '#3565af',
        weight: 1,
        opacity: 1.0,
        fillOpacity: 1,
        pane: 'group4',
      };

      const innerCircleMarker = null;
      const concentricCircleLayer = new L.LayerGroup();
      let marker, iconURL, svgIcon;

      //Color & Size base on fillPercentage
      let icon_size = [10,10];
      let icon_url = '../assets/imgs/tringle_blue.svg';
      // if(fillPercentage != Number.MIN_VALUE){
      //   if(fillPercentage >= 90){
      //     icon_size = [20,20]
      //     icon_url = '../assets/imgs/tringle_red.svg'
      //   }else if(fillPercentage > 40 && fillPercentage < 90){
      //     icon_size = [15,15]
      //     icon_url = '../assets/imgs/tringle_blue.svg'
      //   }else if(fillPercentage <= 40){
      //     icon_size = [10,10]
      //     icon_url = '../assets/imgs/tringle_orange.svg'
      //   }
      // }
      if(alert != undefined){
        if(alert == "warning"){
          icon_size = [15,15]
          icon_url = '../assets/imgs/tringle_orange.svg'
        }else if(alert == 'danger'){
          icon_size = [15,15]
          icon_url =  '../assets/imgs/tringle_red.svg'
        }
        else if(alert =='caution'){
          icon_size = [15,15]
          icon_url = '../assets/imgs/reservoir_alert_caution.svg'  //triangle yellow svg
        }
        else if(alert == 'normal'){
          icon_size = [15,15]
          icon_url = '../assets/imgs/reservoir_alert_normal.svg'  //needs to be changed once we get the triangle green svg
        }
      }

      if (metaDataResult[feature.properties.point_name].point_type == 'RESERVOIR' || metaDataResult[feature.properties.point_name].point_type == 'OS_RESERVOIR' || feature.properties.point_type == 'RESERVOIR' ) {
        const svgIcon2 = new L.Icon({
          iconUrl: icon_url,   //need to check what to show as OS_RES
          iconSize: icon_size,
          iconAnchor: [4, 4],
          popupAnchor: [-5, -5]
        });
        marker = L.marker(latLng, { icon: svgIcon2, pane: 'group4' });

      } else {
        if (metaDataResult[feature.properties.point_name].rtp) {
          // // console.log("inside else if")
          // let svgIcon1 = new L.Icon({
          //   iconUrl: '../assets/imgs/square.svg',
          //   iconSize: [6, 6],
          //   iconAnchor: [4, 4],
          //   popupAnchor: [-5, -5]
          // });
          // marker = L.marker(latLng, { icon: svgIcon1, pane: 'group4' });

          // gis.map.on('zoomend', (e) => {
          //   svgIcon1 = new L.Icon({
          //     iconUrl: '../assets/imgs/square.svg',
          //     iconSize: [gis.map.getZoom() - 1, gis.map.getZoom() - 1],
          //     iconAnchor: [4, 4],
          //     popupAnchor: [-5, -5]
          //   });
          //   marker.setIcon(svgIcon1);
          // });

        } else {
          // console.log("inside else else")
          let svgIcon3 = new L.Icon({
            iconUrl: '../assets/imgs/circle.svg',
            iconSize: [7, 7],
            iconAnchor: [4, 4],
            popupAnchor: [-5, -5]
          });
          marker = L.marker(latLng, { icon: svgIcon3, pane: 'group4' });
          gis.map.on('zoomend', (e) => {
            svgIcon3 = new L.Icon({
              iconUrl: '../assets/imgs/circle.svg',
              iconSize: [gis.map.getZoom(), gis.map.getZoom()],
              iconAnchor: [4, 4],
              popupAnchor: [-5, -5]
            });
            marker.setIcon(svgIcon3);
          });
        }
      }


      concentricCircleLayer.addLayer(marker);

      const popupOptionsHover = {
        minWidth: 350,
        autoPan: false
      };

      gis.map.on('zoomend', (e) => {
      });

      // const last5DayTableData = tableData != null ? tableData : null;
      // const pointTableData = last5DayTableData != null ? (last5DayTableData.computedData[feature.properties.point_name] ? last5DayTableData.computedData[feature.properties.point_name] : null) : '-';
      let totalRainfall :any= 0
      let totalRainfallTMC :any=0
      const ddd: any = metaDataResult[feature.properties.point_name];
      const fiveDayData = this.reservoirData[feature.properties.point_name.toLowerCase()] ? this.reservoirData[feature.properties.point_name.toLowerCase()] : {};
      let timeKeys:any=Object.keys(fiveDayData);
      let reqObj:any={};
      let lstId = timeKeys.length - 1
      reqObj=fiveDayData[timeKeys[lstId]] ? fiveDayData[timeKeys[lstId]] : {};
      const timestamp = reqObj.lt;
      let date = new Date(timestamp);
      let dateLst = date.toString().split(' ')
      dateLst = dateLst.splice(1, 4)
      let dateStr = dateLst.join(' ')
      let fnlDateStr = dateStr.slice(0, dateStr.length - 3)
      let string_text = '<html><body>';
      ddd.basin = ddd.basin === null ? 'GODAVARI-BASIN' : ddd.basin;
      string_text += '<div class="popup-table-section">';
      string_text += ' <div class="card-body p-0">';
      string_text += '<table class=\'table table-text-sm -mis table-sm  m-0 table-bordered text-nowrap text-center\' >';
      string_text += '<thead class=\'\'><tr><h6 class=\'text-center\' style=\'font-weight:bold;\'>' + ddd.point_name.replace(/FFS|_FFS/g, '') + '(' + ddd.basin + ')' + '</h6><tr></thead>';
      string_text += '<tbody>';
      if (ddd.cap != null) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Capacity(TMC) </span></td><td style=\' text-transform:none\'>' + ddd.cap.toFixed(2) + ' T.M.C' + '</td></tr>';
      }
      if (reqObj.st != null) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Current Storage(TMC) </span></td><td style=\' text-transform:none\'>' + reqObj.st + ' T.M.C' + '</td></tr>';
      }
      if (ddd.ds != null) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Dead Storage(TMC) </span></td><td style=\' text-transform:none\'>' + ddd.ds.toFixed(2) + ' T.M.C' + '</td></tr>';
      }
      if (reqObj.lt != null) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Date & Time </span></td><td style=\' text-transform:none\'>' + fnlDateStr + '</td></tr>';
      }
      if (ddd.cap != null) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Flood Cushion </span></td><td style=\' text-transform:none\'>' + (ddd.cap -reqObj.st).toFixed(2) + ' T.M.C' + '</td></tr>';
      }
      if (ddd.cst != null && ddd.cst > 0.0 && ddd.dn != null && ddd.dn > 0.0) {
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Travel Time(Hrs) </span></td><td style=\' text-transform:none\'>' + ddd.cst.toFixed(2) + ' Hours' + '</td></tr>';
        string_text += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >Downstream Distance(KM) </span></td><td style=\' text-transform:none\'>' + ddd.dn.toFixed(2) + ' Kms' + '</td></tr>';
      }
      if (ddd.lat != null && ddd.lon != null) {
        string_text += '<tr><td style=\' text-transform:none\'><span style=\'text-transform:capitalize\'>GPS</span></td><td style=\'text-transform:none\'>' + ddd.lat.toFixed(3) + ' , ' + ddd.lon.toFixed(3) + '</td></tr>';
        //  string_text += "<tr><td style='text-transform:none'><span style='text-transform:capitalize'>Longitude</span></td><td style='text-transform:none'>" + ddd.lon.toFixed(5) + "</td></tr>";
      }

      string_text += '<tr></tr>';
      string_text += '</tbody>';
      string_text += '<table class=\'table table-text-sm -mis table-sm  m-0 table-bordered text-nowrap text-center\' >';

      if (metaDataResult[feature.properties.point_name].rtp || metaDataResult[feature.properties.point_name].point_type == 'RESERVOIR' || metaDataResult[feature.properties.point_name].point_type == 'OS_RESERVOIR') {
        // if (metaDataResult[feature.properties.point_name].point_type == 'RESERVOIR' || metaDataResult[feature.properties.point_name].point_type == 'OS_RESERVOIR') {
        //   string_text += '<tr id=\'head\' style=\'background-color:#3E3E43;height:30px;\'><th>Date</th><th>Storage (T.M.C)</th><th>Flow (m)</th></tr>';
        // } else {
        //   string_text += '<tr id=\'head\' style=\'background-color:#3E3E43;height:30px;\'><th>Date</th><th>Flow (m)</th><th>Level(m) / Depth(m)</th></tr>';
        // }
        // string_text += '<tbody align=\'center\'>';

        if (metaDataResult[feature.properties.point_name].point_type == 'RESERVOIR' || metaDataResult[feature.properties.point_name].point_type == 'OS_RESERVOIR') {
          const fiveDayData = this.reservoirData[feature.properties.point_name.toLowerCase()] ? this.reservoirData[feature.properties.point_name.toLowerCase()] : {};
          if (!isNullOrUndefined(fiveDayData) && Object.keys(fiveDayData).length > 0) {
            string_text += '<tr id=\'head\' style=\'background-color:#3E3E43;height:30px;\'><th>Date</th><th>Storage (T.M.C)</th><th>Flow (Cusec)</th></tr>';
            string_text += '<tbody align=\'center\'>';
          }
          for (const key in fiveDayData) {
            const timeStamp = moment(parseInt(key)).format('DD/MM/YYYY HH:mm');

            const storage = fiveDayData[key].st || fiveDayData[key].st >= 0 ? fiveDayData[key].st.toFixed(3) : '-';
            const resinflow = (fiveDayData[key].if || fiveDayData[key].if >= 0) ? fiveDayData[key].if.toFixed(1) : '-';
            const resoutflow = (fiveDayData[key].of || fiveDayData[key].of >= 0) ? fiveDayData[key].of.toFixed(1) : '-';

            string_text += '<tr>' +
              '<td>' + timeStamp + '</td>' +
              '<td>' + storage + '</td>' +
              '<td>' + resinflow + ' / ' + resoutflow + '</td></tr>';
          }

        } else {
          const fiveDayRiverGaugeData = this.riverGaugeData[feature.properties.point_name] ? this.riverGaugeData[feature.properties.point_name] : {};
          if (!isNullOrUndefined(fiveDayRiverGaugeData) && Object.keys(fiveDayRiverGaugeData).length > 0) {
            string_text += '<tr id=\'head\' style=\'background-color:#3E3E43;height:30px;\'><th>Date</th><th>Storage (T.M.C)</th><th>Flow (m)</th></tr>';
            string_text += '<tbody align=\'center\'>';
          }
          for (const key in fiveDayRiverGaugeData) {
            const flowTimeStamp = moment(parseInt(key)).format('DD/MM/YYYY HH:mm');
            const level = fiveDayRiverGaugeData[key].l || fiveDayRiverGaugeData[key].l >= 0 ? fiveDayRiverGaugeData[key].l.toFixed(1) : '-';
            const flow = fiveDayRiverGaugeData[key].f || fiveDayRiverGaugeData[key].f >= 0 ? fiveDayRiverGaugeData[key].f.toFixed(1) : '-';
            const depth = fiveDayRiverGaugeData[key].d || fiveDayRiverGaugeData[key].d >= 0 ? fiveDayRiverGaugeData[key].d.toFixed(1) : '-';

            string_text += '<tr>' +
              '<td>' + flowTimeStamp + '</td>' +
              '<td>' + flow + '</td>' +
              '<td>' + level + ' / ' + depth + '</td>' +
              '</tr>';
          }

        }

        if (metaDataResult[feature.properties.point_name].point_type == 'RESERVOIR' || metaDataResult[feature.properties.point_name].point_type == 'OS_RESERVOIR') {
          string_text += '<tr id=\'head\' style=\'background-color:#3E3E43;height:30px;\'><th>Catchment Rainfall</th><th>mm</th><th>(T.M.C)</th></tr>';
            string_text += '<tbody align=\'center\'>';
            if(resCatch && resCatch[metaDataResult[feature.properties.point_name].uuid]){
              let resdata = resCatch[metaDataResult[feature.properties.point_name].uuid]
              let timeStamp
              let rainfallmm
              let rainfallTMC
              for (const key in resdata) {
                timeStamp =  moment(parseInt(key)).format('DD/MM/YYYY HH:mm')
                       rainfallmm = (resdata[key].rainfallValue).toFixed(4)
                       totalRainfall = totalRainfall + Number(rainfallmm)
                       rainfallTMC =   (resdata[key].rainfallStorage).toFixed(6)
                       totalRainfallTMC += Number(rainfallTMC)



               string_text += '<tr>' +
               '<td>' + timeStamp + '</td>' +
               '<td>' + rainfallmm + '</td>' +
               '<td>' + rainfallTMC + '</td></tr>';
              }
              }
          }
      }
      totalRainfall= totalRainfall.toFixed(4)
      totalRainfallTMC = totalRainfallTMC.toFixed(6)
      string_text += '<tr>' +
      '<td>' +'TOTAL' +'</td>' +
    '<td>' +totalRainfall +'</td>' +
    '<td>' +totalRainfallTMC +'</td>'
    '</tr>'
      string_text += '</tbody></table>';
      string_text += '</table></div></div></body></html>';
      // marker.bindPopup('loading...', popupOptionsHover);
      let isPopupOpen;
      marker.on({
        // mouseover: (e) => {

        //   const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: false }).setContent(string_text);
        //   marker.bindPopup(popup).openPopup();
        // },
        // mouseout: (e) => {
        //   setTimeout(() => {
        //     marker.closePopup();
        //   }, 1000);

        // },
        click: (e) => {
          console.log("@@S",e)
          this.utilsSrv.setFloodData(string_text);
          // gis.layersList.overlayLayers['Full Catchment'].clearLayers();
          gis.layersList.overlayLayers['Self Catchment'].clearLayers();
          let isPopupOpen = 0;
          this.isActiveSpinner.next(true);
          if (!isNullOrUndefined(this.previousLayer)) {
            if (gis.map.hasLayer(this.previousLayer)) {
              gis.map.removeLayer(this.previousLayer);
            }
          }
          const newfilter = {
            filter: 'poi_name = \'' + point_name + '\''
          };
          console.log("ardata",arData)
          const newfilters = {
            filter: 'uuid = \'' + arData['uuid'] + '\'',
            tnFilter: 'poi_uuid = \'' + arData['location_u'] + '\'',
            odFilter: 'poi_uuid = \'' + arData['location_u'] + '\'',
            kwFilter: 'res_uuid = \'' + arData['uuid'] + '\''


          };
          // this.geInnundationtGeoJSONData('kaleshwaram:godavari_custom_catchment_v2', newfilter).subscribe(jsonData => {
          // this.geInnundationtGeoJSONData('forecast:FLOODFORECAST_CATCHMENTS', newfilters).subscribe(jsonData => {
          //   if (jsonData.features.length == 0) {
          //     this.isActiveSpinner.next(false);
          //   }
            // const gecLayerObj = new (L as any).geoJSON(jsonData, {
            //   pane: 'group3',
            //   name: 'catchment',
            //   style: this.stylingforGeoJson,
            //   onEachFeature: (feature, layer) => {
            //     gis.map.addLayer(layer);
            //     this.previousLayer = layer;
            //     this.isActiveSpinner.next(false);
            //   }
            // });
            // gis.layersList.overlayLayers['Full Catchment'].addData(jsonData);
            this.geInnundationtGeoJSONData('HEATWAVE:AP_CATCHMENT_AREA', newfilters).subscribe(geoJsonData => {   // add catchment layers
              if (geoJsonData.features.length == 0) {
                this.isActiveSpinner.next(false);
              }
              const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
                pane: 'group3',
                name: 'catchment',
                style: this.stylingforGeoJson,
                onEachFeature: (feature, layer) => {
                  gis.map.addLayer(layer);
                  this.previousLayer = layer;
                  this.isActiveSpinner.next(false);
                }
              });
              gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            });
            this.geInnundationtGeoJSONData('HEATWAVE:KL_CATCHMENT_AREA', newfilters).subscribe(geoJsonData => {   // add catchment layers
              if (geoJsonData.features.length == 0) {
                this.isActiveSpinner.next(false);
              }
              const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
                pane: 'group3',
                name: 'catchment',
                style: this.stylingforGeoJson,
                onEachFeature: (feature, layer) => {
                  gis.map.addLayer(layer);
                  this.previousLayer = layer;
                  this.isActiveSpinner.next(false);
                }
              });
              gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            });
            this.geInnundationtGeoJSONData('HEATWAVE:OD_CATCHMENT_AREA', newfilters).subscribe(geoJsonData => {   // add catchment layers
              if (geoJsonData.features.length == 0) {
                this.isActiveSpinner.next(false);
              }
              const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
                pane: 'group3',
                name: 'catchment',
                style: this.stylingforGeoJson,
                onEachFeature: (feature, layer) => {
                  gis.map.addLayer(layer);
                  this.previousLayer = layer;
                  this.isActiveSpinner.next(false);
                }
              });
              gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            });
            this.geInnundationtGeoJSONData('HEATWAVE:TNCATCHMENT_AREA', newfilters).subscribe(geoJsonData => {   // add catchment layers
              if (geoJsonData.features.length == 0) {
                this.isActiveSpinner.next(false);
              }
              const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
                pane: 'group3',
                name: 'catchment',
                style: this.stylingforGeoJson,
                onEachFeature: (feature, layer) => {
                  gis.map.addLayer(layer);
                  this.previousLayer = layer;
                  this.isActiveSpinner.next(false);
                }
              });
              gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            });
            // this.geTNInnundationtGeoJSONData('tamilnadu_pennaiyar_self_catchments', newfilters).subscribe(geoJsonData => {   // add catchment layers
            //   if (geoJsonData.features.length == 0) {
            //     this.isActiveSpinner.next(false);
            //   }
            //   const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
            //     pane: 'group3',
            //     name: 'catchment',
            //     style: this.stylingforGeoJson,
            //     onEachFeature: (feature, layer) => {
            //       gis.map.addLayer(layer);
            //       this.previousLayer = layer;
            //       this.isActiveSpinner.next(false);
            //     }
            //   });
            //   gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            // });
            // this.geODInnundationtGeoJSONData('mahanadi_rushikulya_baitarani_brahmani_self_catchment', newfilters).subscribe(geoJsonData => {   // add catchment layers
            //   if (geoJsonData.features.length == 0) {
            //     this.isActiveSpinner.next(false);
            //   }
            //   const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
            //     pane: 'group3',
            //     name: 'catchment',
            //     style: this.stylingforGeoJson,
            //     onEachFeature: (feature, layer) => {
            //       gis.map.addLayer(layer);
            //       this.previousLayer = layer;
            //       this.isActiveSpinner.next(false);
            //     }
            //   });
            //   gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            // });
            // this.geODInnundationtGeoJSONData('mahanadi_self_catchment_11may', newfilters).subscribe(geoJsonData => {   // add catchment layers
            //   if (geoJsonData.features.length == 0) {
            //     this.isActiveSpinner.next(false);
            //   }
            //   const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
            //     pane: 'group3',
            //     name: 'catchment',
            //     style: this.stylingforGeoJson,
            //     onEachFeature: (feature, layer) => {
            //       gis.map.addLayer(layer);
            //       this.previousLayer = layer;
            //       this.isActiveSpinner.next(false);
            //     }
            //   });
            //   gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            // });
            // this.geKWInnundationtGeoJSONData('KWRIS:flood_forecast_catchments', newfilters).subscribe(geoJsonData => {   // add catchment layers
            //   if (geoJsonData.features.length == 0) {
            //     this.isActiveSpinner.next(false);
            //   }
            //   const gecLayerObj = new (L as any).geoJSON(geoJsonData, {
            //     pane: 'group3',
            //     name: 'catchment',
            //     style: this.stylingforGeoJson,
            //     onEachFeature: (feature, layer) => {
            //       gis.map.addLayer(layer);
            //       this.previousLayer = layer;
            //       this.isActiveSpinner.next(false);
            //     }
            //   });
            //   gis.layersList.overlayLayers['Self Catchment'].addData(geoJsonData);
            // });
          // });

          arData = metaDataResult[feature.properties.point_name];
          urlParams.pointType = urlParams.pointType ? 'project' : urlParams.pointType;
          urlParams.point = urlParams.pointType === 'project' ? arData.point_name.trim() : null;
          urlParams.heatmapReload = false;
          // let stateUUID = this.route.snapshot.paramMap.get('id');
          const baseUrl = 'floodforecast/gis' + '/' + stateUUID;
          this.isOpenDataTab.next(true);
          urlParams.showSensorLayer = false;
          this.router.navigate([baseUrl, urlParams]);
          isPopupOpen = 1;
        }
      });

      // SET MOBILE VIEW
      if (L.Browser.mobile) {
        let isPopupOpen = 0;
        marker.on({
          click: (e) => {
            const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [1, 2], minWidth: 360, maxWidth: 450, closeButton: false }).setContent(string_text);
            marker.bindPopup(popup).openPopup();
            arData = metaDataResult[feature.properties.point_name];
            urlParams.pointType = urlParams.pointType ? 'project' : urlParams.pointType;
            urlParams.point = urlParams.pointType === 'project' ? arData.point_name.trim() : null;
            urlParams.heatmapReload = false;
            // let stateUUID = this.route.snapshot.paramMap.get("id");
            const baseUrl = 'floodforecast/gis' + '/' + stateUUID;
            this.isOpenDataTab.next(true);
            this.router.navigate([baseUrl, urlParams]);
            isPopupOpen = 1;
          }
        });
      }

      return concentricCircleLayer;
    }
  }

  getMarkerRadius(zoomLevel) {
    const zoomRadius = {
      5: 1,
      7: 2.4,
      9: 4,
      11: 8,
      15: 10,
      24: 12
    };
    for (const zoom in zoomRadius) {
      if (zoomLevel <= parseInt(zoom, 10)) {
        return zoomRadius[zoom];
      }
    }
    return 2.4;
  }

  onEachFeature(feature, layer, modalSrv, flowType, metaData, urlParams, stateUUID) {
    layer.on({
      click: (e) => {
        this.onRiverClick(e, modalSrv, flowType, metaData, urlParams, stateUUID);
      }
    });
  }
  onRiverClick(e, modalSrv, flowType, metaData, urlParams, stateUUID) {
    let arData = null;
    let point: String;
    const temp = (e.target.feature.properties.downstream === 'UNIVERSAL_SINK_NODE' || e.target.feature.properties.downstream == null) ? e.target.feature.properties.upstream_p : e.target.feature.properties.downstream;
    arData = metaData[temp];

    urlParams.pointType = urlParams.pointType ? 'project' : urlParams.pointType;
    urlParams.point = urlParams.pointType === 'project' ? arData.point_name.trim() : null;
    // let stateUUID = this.route.snapshot.paramMap.get('id');
    const baseUrl = 'floodforecast/gis' + '/' + stateUUID;
    this.isOpenDataTab.next(true);
    urlParams.showSensorLayer = false;
    this.router.navigate([baseUrl, urlParams]);

  }

  getShapeBoundaryLayersForRegions(options, regionSelected) {
    const shapeBoundary = new Promise((resolve) => {
      if (isNullOrUndefined(this.shpBoundaryLayers[regionSelected])) {
        if (options == undefined) { resolve(null); }
        const layerName = MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + options.layerName;
        let boundaryURL = MapConstants.GEOJSON_LAYER_URL + '&typeName=' + layerName;
        if (!isNullOrUndefined(options.cql_filter)) {
          boundaryURL = boundaryURL + '&cql_filter=' + options.cql_filter;
        }
        this.http.get(boundaryURL).subscribe(
          data => {
            this.shpBoundaryLayers[regionSelected] = data['features'][0]['geometry'];
            resolve(this.shpBoundaryLayers[regionSelected]);
          });
      } else {
        resolve(this.shpBoundaryLayers[regionSelected]);
      }
    });
    return shapeBoundary;
  }

  createCroppedHeatMapLayer(layer, filterOptions, regionSelected) {
    const layerPromise = new Promise((resolve, reject) => {
      const options = {
        opacity: 0.8,
        pane: 'group0',
        minZoom: 6,
        maxZoom: 15
      };

      const bounds = {
        y_min: 11.15,
        x_min: 73.3,
        y_max: 22.7,
        x_max: 85.25
      };

      const anchors = [[bounds.y_max, bounds.x_min], [bounds.y_max, bounds.x_max],
      [bounds.y_min, bounds.x_max], [bounds.y_min, bounds.x_min]];
      this.getShapeBoundaryLayersForRegions(filterOptions, regionSelected).then(
        data => {
          if (data != null) {
            options['clip'] = data;
          }
          if (layer.url != null && layer.url != undefined) {
            this.floodDataService.getRainfallHeatMapData(layer.url, layer.postData).subscribe(
              data => {
                // console.log(data);
                // var anchors = this.getImageBounds(data);
                if (data != null && data != undefined) {
                  layer['layer'] = L.imageTransform(data, anchors, options);
                }
                resolve(layer);
              });
          }
        });
    });
    return layerPromise;
  }
  getCurrentDayInflowTimestamp(){
    let date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    let time = date.getTime().toString();
    let timestepvalue = Number(time.substring(0,10) + '000')
    return timestepvalue;
  }

  drawFloodForecastRivers(geoJson, flowType, metaData, modalSrv, urlParams, stateUUID,riverData) {
    const metaDataResult = metaData;
    let timeStamp = this.getCurrentDayInflowTimestamp();
    return new Promise((resolve, reject) => {
      this.getBasinDailyTableData().subscribe(data => {
        let DataObj = {};
        if(riverData != null || riverData != undefined){

          Object.keys(riverData).forEach(key=>{
            DataObj[key] = {};
            Object.keys(riverData[key]).forEach(key2=>{
                  DataObj[key]['inflowvalue'] = (riverData[key][key2]['-7']);


            });
          })
        }
        this.riverNetworkLayerStyling  = DataObj;
        const riverLayer = L.geoJSON(geoJson, {
          style: getRiverStyle,
          onEachFeature: (feature, layer) => this.onEachFeature(feature, layer, modalSrv, flowType, metaData, urlParams, stateUUID)
        });

        function getRiverStyle(feature) {
  // add condition for coloring of river for different layer
          return {
            // fillColor: "red",
            weight: 2.2,
            opacity: 1.0,
            color: getColor(feature,feature.properties),
            fillOpacity: 0.8,
            pane: 'group2'
          };
        }

        function getColor(feature,downPoint) {
          let firstKey = null;
          let value = null;

        if(downPoint.basin == 'Pennaiyar'){
                    Object.keys(DataObj).forEach(key => {
                      if (downPoint.downstre_1) {
                        if(key ==  downPoint.downstre_1){
                          value = DataObj[key]['inflowvalue'];
                        }
                      }
                    })
                  }
        if(downPoint.basin == 'MAHANADI'){
                    Object.keys(DataObj).forEach(key => {
                      if (downPoint.downstre_1) {
                        if(key ==  downPoint.downstre_1){
                          value = DataObj[key]['inflowvalue'];
                        }
                      }
                    })
                  }
        if(downPoint.basin == 'BAITARNI'){
                    Object.keys(DataObj).forEach(key => {
                      // if (downPoint.downstre_1) {
                        // if(key ==  downPoint.downstre_1){
                          value = DataObj[key]['inflowvalue'];
                        // }
                      // }
                    })
                  }
        if(downPoint.basin == 'BRAHMANI'){
                    Object.keys(DataObj).forEach(key => {
                      // if (downPoint.downstre_1) {
                      //   if(key ==  downPoint.downstre_1){
                          value = DataObj[key]['inflowvalue'];
                      //   }
                      // }
                    })
                  }
        if(downPoint.basin == 'RUSHIKULYA'){
                    Object.keys(DataObj).forEach(key => {
                      // if (downPoint.downstre_1) {
                      //   if(key ==  downPoint.downstre_1){
                          value = DataObj[key]['inflowvalue'];
                      //   }
                      // }
                    })
                  }
        if(downPoint.imp == 'Y'){
                    Object.keys(DataObj).forEach(key => {
                      if (downPoint.seg_uuid) {

                          value = DataObj[key]['inflowvalue'];

                      }
                    })
                  }
          if (data.computedData[downPoint.upstream_p] != undefined) {
            firstKey = Object.keys(data.computedData[downPoint.upstream_p])[0];
            value = data.computedData[downPoint.upstream_p][firstKey].dsof;
            console.log("🚀 ~ file: flood-forecast-map.service.ts:1578 ~ getColor ~ value:", value)
          }

          if (data.computedData[downPoint.downstream] != undefined) {
            firstKey = Object.keys(data.computedData[downPoint.downstream])[0];
            value = data.computedData[downPoint.downstream][firstKey].in;
            console.log("🚀 ~ file: flood-forecast-map.service.ts:1584 ~ getColor ~ value:", value)
          }

          if (value == undefined || value == null) {
            return '#D3DADC';
          }

          if (value >= 0 && value <= 250) {
            return '#b6d1ff';
          } else if (value > 250 && value <= 2500) {
            return ' #7dacfb';
          } else if (value > 2500 && value <= 5000) {
            return '#4e8ffd';
          } else if (value > 5000 && value <= 10000) {
            return '#1560e0';
          } else if (value > 10000 && value <= 25000) {
            return '#003288';
          } else if (value > 25000 && value <= 50000) {
            return '#ffa198';
          } else if (value > 50000 && value <= 100000) {
            return '#fb7276';
          } else if (value > 100000 && value <= 500000) {
            return '#fa050c';
          } else if (value > 500000 && value <= 1000000) {
            return '#bb0005';
          } else if (value > 1000000) {
            return '#7e0000';
          } else {
            return '#949292';
          }
        }

        resolve(riverLayer);
      });
    });
  }

  getMarkerRadius2(zoomLevel, currentRadius) {
    return currentRadius * zoomLevel * 0.2;
  }

  processSensorData(parentName, urlParams, modalSrv, startTs, endTs, legendData, map) {

    return new Promise((resolve, reject) => {
      const sensorList = {};
      sensorList['rainfall'] = 'sensorDate';
      let pUUID, pEUUID, pType, startDate, endDate, jsond, marker;
      startDate = moment(startTs).format('YYYYMMDD');
      endDate = moment(endTs).format('YYYYMMDD');
      let timeStep = urlParams.timeStep;
      timeStep = timeStep.toUpperCase();
      if (!timeStep) {
        timeStep = 'DAILY';
      }
      if (timeStep == 'DAILY') {
        startDate = moment(startTs).format('YYYYMMDD');
        endDate = moment(endTs).format('YYYYMMDD');
      } else if (timeStep == 'YEARLY') {
        startDate = moment(startTs).format('YYYY');
        endDate = moment(endTs).format('YYYY');
      } else if (timeStep == 'MONTHLY') {
        startDate = moment(startTs).format('YYYYMM');
        endDate = moment(endTs).format('YYYYMM');
      }
      if (parentName == 'GODAVARI-BASIN') {
        pUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
        pEUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
        pType = 'BASIN';
      } else if (parentName == 'SOUTHZONE_FLOW_NETWORK') {
        pUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'REGION';
      } else if (parentName == 'GODAVARI-TELANGANA') {
        pUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
        pEUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
        pType = 'REGION';
      } else if (parentName == 'ANDHRA_PRADESH') {
        pUUID = '6f86292b-dd9a-4987-bb8f-c3940263b349';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'STATE';
      } else if (parentName == 'KRISHNA_BASIN') {
        pUUID = '96c6680b-d232-46d0-ac43-2542f59b939b';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'PENNAR_BASIN') {
        pUUID = 'f4778def-1f0e-4f00-8274-49ce3cc8b169';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'VAMSADHARA_BASIN') {
        pUUID = '20f19293-7286-11ea-89f5-1002b57d618a';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'NAGAVALI_BASIN') {
        pUUID = '291071e0-7286-11ea-89f5-1002b57d618a';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      }
      const postData = {
        pUUID, pType, cType: 'RAINFALL', format: timeStep,
        src: 'STATE_AND_CENTRAL_STATIONS', view: 'ADMIN', sDate: startDate, eDate: endDate,
        aggr: 'SUM', pEUUID, classification: ['ACTUAL']
      };
      const promise1 = new Promise((resolve, reject) => {
        // this.getRainfallDataforthisRegion(postData).subscribe(data => {
        //   resolve(data);
        // });
      });

      promise1.then((jsonData) => {
        const layers = {};
        const result: any = jsonData;
        const sDate = moment(startTs).format('DD/MM/YYYY');
        const eDate = moment(endTs).format('DD/MM/YYYY');
        for (const key in sensorList) {
          const layerKey = 'sensor' + key;
          layers[layerKey] = new L.LayerGroup();
          for (const id in result) {
            const info = result[id];
            const newmarker = this.createNewMarker(info, urlParams, modalSrv, legendData, map, sDate, eDate, pEUUID);
            layers[layerKey].addLayer(newmarker);
          }
        }
        resolve(layers);
      });
    });


  }

  createNewMarker(info, urlParams, modalSrv, legendData, map, sDate, eDate, pEUUID) {
    let latLangArray: [number, number];
    let latitude, longitude, rfLevel, timestamp;
    latitude = info['md']['lt'] ? info['md']['lt'].toFixed(4) : 0;
    longitude = info['md']['lng'] ? info['md']['lng'].toFixed(4) : 0;
    rfLevel = info['al'] >= 0 ? info['al'].toFixed(2) : '-';
    if (sDate === eDate) {
      timestamp = moment(info['ts']).format('DD/MM/YYYY HH:mm:ss');
    } else {
      timestamp = sDate + '-' + eDate;
    }
    latLangArray = [latitude, longitude];
    const stateName = info['md'] ? info['md']['snm'] : '-';
    const stationName = info['nm'] ? info['nm'] : '-';

    const outerCircleOptions = {
      stroke: true,
      fill: true,
      color: 'black',
      weight: 0.7,
      fillColor: 'white',
      fillOpacity: 1,
      radius: 2.5,
      opacity: 1.0,
      interactive: true,
      pane: 'group5'
    };
    // console.log(legendData)
    const fill = this.getRainfallFillColor(rfLevel, legendData);
    outerCircleOptions.fillColor = fill;
    const marker = L.circleMarker(latLangArray, outerCircleOptions);
    let htmlString = '<html><body>';
    htmlString += '<div class="popup-table-section">';
    htmlString += ' <div class="card-body p-0">';
    htmlString += '<table class=\'table table-text-sm -mis table-sm  m-0 table-bordered text-nowrap text-center\' >';
    htmlString += '<thead class=\'\'><tr><h5 class=\'text-center\' style=\'font-weight:bold\'>Rainfall</h5><tr></thead>';
    htmlString += '<tbody>';
    htmlString += '<tr><td style=\'text-transform:uppercase\'><span style=\'text-transform:capitalize\'>Station Name</span></td><td style=\'text-transform:none\'  id=\'station\'>' + stationName.replace(/AWS|_AWS/g, '') + '</td></tr>';
    htmlString += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\' >State Name</span></td><td style=\' text-transform:none\' id=\'state\'>' + stateName + '</td></tr>';
    htmlString += '<tr><td style=\' text-transform:none\'><span style=\'text-transform:capitalize\'>Latitude</span></td><td style=\'text-transform:none\'>' + latitude + '</td></tr>';
    htmlString += '<tr><td style=\'text-transform:none\'><span style=\'text-transform:capitalize\'>Longitude</span></td><td style=\'text-transform:none\'>' + longitude + '</td></tr>';
    if (parseFloat(rfLevel) >= 0) {
      htmlString += '<tr><td style=\' text-transform:none\'><span style=\'text-transform:capitalize\'>Rainfall Level</span></td><td id=\'rf\' style=\'text-transform:none\'>' + rfLevel + ' mm</td></tr>';
    }
    htmlString += '<tr><td style=\' text-transform:none\'><span style=\'text-transform:capitalize\'>TimeStamp</span></td><td id=\'time\' style=\'text-transform:none\'>' + timestamp + '</td></tr>';
    htmlString += '<tr></tr>';
    htmlString += '</tbody></table></div></div></body></html>';

    marker.bindPopup('loading...', { autoPan: false, });
    marker.on({
      mouseover: (e) => {
        const popup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [1, 2] }).setContent(htmlString);
        marker.bindPopup(popup).openPopup();
        marker.setStyle({ color: 'black', weight: 2 });
      },
      mouseout: (e) => {
        marker.setStyle({ color: 'black', weight: 1 });
        setTimeout(() => {
          marker.closePopup();
        }, 1000);
      },
      click: (e) => {
        urlParams.heatmapReload = false;
        urlParams.pointType = urlParams.pointType ? 'station' : urlParams.pointType;
        urlParams.point = urlParams.pointType === 'station' ? info['uid'] : null;
        urlParams.pEUUID = pEUUID;
        urlParams.pUUID = info['uid'];
        const baseUrl = 'floodforecast/gis' + '/akbm';
        this.isOpenDataTab.next(true);
        if (this.previousLayer != undefined && map.hasLayer(this.previousLayer)) {
          map.removeLayer(this.previousLayer);
          this.previousLayer = undefined;
        }
        urlParams.showSensorLayer = false;
        this.router.navigate([baseUrl, urlParams]);
      }
    });

    // MOBILE VIEW CLICK PROPERTY
    if (L.Browser.mobile) {
      const isPopupOpen = 0;
      marker.on({
        click: (e) => {
          if (this.previousLayer != undefined && map.hasLayer(this.previousLayer)) {
            map.removeLayer(this.previousLayer);
            this.previousLayer = undefined;
          }
          const popup = R.responsivePopup({ hasTip: true, autoPan: false, offset: [1, 2] }).setContent(htmlString);
          marker.bindPopup(popup).openPopup();
          marker.setStyle({ color: 'black', weight: 2 });
          urlParams.heatmapReload = false;
          urlParams.pointType = urlParams.pointType ? 'station' : urlParams.pointType;
          urlParams.point = urlParams.pointType === 'station' ? info['uid'] : null;
          urlParams.pEUUID = pEUUID;
          const baseUrl = 'floodforecast/gis' + '/akbm';
          urlParams.pUUID = info['uid'];
          this.isOpenDataTab.next(true);
          urlParams.showSensorLayer = false;
          this.router.navigate([baseUrl, urlParams]);
        }
      });

      marker.on('popupclose', () => {
        if (isPopupOpen) {
          marker.setStyle({ color: 'black', weight: 1 });
        }
      });

    }

    const initialZoom = map.getZoom();
    map.on({
      zoomend: (e: L.LeafletEvent) => {
        const currZoom = map.getZoom();
        const diff = initialZoom - currZoom;
        if (diff > 0) {
          const newinnrad = this.getCircleMarkerRadiusForStation(map.getZoom(), outerCircleOptions.radius) - Math.abs(diff);
          marker.setRadius(newinnrad / 1.3);// add this line to change the style
        } else if (diff < 0 && currZoom > initialZoom) {
          const newinnrad = map.getZoom() / 2 + outerCircleOptions.radius + Math.abs(diff);
          marker.setRadius(newinnrad / 2);// add this line to change the style
        } else {
          marker.setRadius(outerCircleOptions.radius);
        }
      },

    });

    return marker;
  }

  getCircleMarkerRadiusForStation(zoomLevel, currentRadius) {
    return zoomLevel - currentRadius;
  }

  getFillColor(rainfallLevel, legendData) {
    rainfallLevel = parseFloat(rainfallLevel);
    for (const level in legendData) {
      if (rainfallLevel <= level) {
        return legendData[level];
      }
    }
    return '#DCDCDC';
  }

  getRainfallFillColor(rainfallLevel, legendData) {
    rainfallLevel = parseFloat(rainfallLevel);
    for (const index in legendData) {
      const level = legendData[index].level;
      if (rainfallLevel <= level) {
        return legendData[index].color;
      }
    }
    return '#DCDCDC';
  }

  processAllSensorData(parentName, urlParams, modalSrv, startTs, endTs, legendData, map) {

    return new Promise((resolve, reject) => {
      const sensorList = {};
      sensorList['rainfall'] = 'sensorDate';
      let pUUID, pEUUID, pType, startDate, endDate, jsond, marker;
      startDate = moment(startTs).format('YYYYMMDD');
      endDate = moment(endTs).format('YYYYMMDD');
      let timeStep = urlParams.timeStep;
      timeStep = timeStep.toUpperCase();
      if (!timeStep) {
        timeStep = 'DAILY';
      }
      if (timeStep == 'DAILY') {
        startDate = moment(startTs).format('YYYYMMDD');
        endDate = moment(endTs).format('YYYYMMDD');
      } else if (timeStep == 'YEARLY') {
        startDate = moment(startTs).format('YYYY');
        endDate = moment(endTs).format('YYYY');
      } else if (timeStep == 'MONTHLY') {
        startDate = moment(startTs).format('YYYYMM');
        endDate = moment(endTs).format('YYYYMM');
      }
      if (parentName == 'GODAVARI-BASIN') {
        pUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
        pEUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
        pType = 'BASIN';
      } else if (parentName == 'SOUTHZONE_FLOW_NETWORK') {
        pUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'REGION';
      } else if (parentName == 'GODAVARI-TELANGANA') {
        pUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
        pEUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
        pType = 'REGION';
      } else if (parentName == 'ANDHRA_PRADESH') {
        pUUID = '6f86292b-dd9a-4987-bb8f-c3940263b349';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'STATE';
      } else if (parentName == 'KRISHNA_BASIN') {
        pUUID = '96c6680b-d232-46d0-ac43-2542f59b939b';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'PENNAR_BASIN') {
        pUUID = 'f4778def-1f0e-4f00-8274-49ce3cc8b169';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'VAMSADHARA_BASIN') {
        pUUID = '20f19293-7286-11ea-89f5-1002b57d618a';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      } else if (parentName == 'NAGAVALI_BASIN') {
        pUUID = '291071e0-7286-11ea-89f5-1002b57d618a';
        pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
        pType = 'BASIN';
      }
      const postData = {
        pUUID, pType, cType: 'RAINFALL', format: timeStep,
        src: 'STATE_AND_CENTRAL_STATIONS', view: 'ADMIN', sDate: startDate, eDate: endDate,
        aggr: 'SUM', pEUUID, classification: ['ACTUAL'], includeAllLoc: true
      };
      const promise1 = new Promise((resolve, reject) => {
        // this.getRainfallDataforthisRegion(postData).subscribe(data => {
        //   resolve(data);
        // });
      });

      promise1.then((jsonData) => {
        const layers = {};
        const result: any = jsonData;
        const sDate = moment(startTs).format('DD/MM/YYYY');
        const eDate = moment(endTs).format('DD/MM/YYYY');
        for (const key in sensorList) {
          const layerKey = 'sensor' + key;
          layers[layerKey] = new L.LayerGroup();
          for (const id in result) {
            const info = result[id];
            const newmarker = this.createNewMarker(info, urlParams, modalSrv, legendData, map, sDate, eDate, pEUUID);
            layers[layerKey].addLayer(newmarker);
          }
        }
        resolve(layers);

      });
    });


  }

  geInnundationtGeoJSONData(layer, options) {
    // const layerURL = this.getInundationCompGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let url = ProjConstants.GEOSERVER_URL+'geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let l = 'http://geo.vassarlabs.com/geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    let l = this.getInundationCompGeoServerURLForecast() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (options.filter) {
      l += '&cql_filter=' + options.filter;
    }
    return this.http.get<any>(l);
  }
  geTNInnundationtGeoJSONData(layer, options) {
    // const layerURL = this.getInundationCompGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let url = ProjConstants.GEOSERVER_URL+'geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let l = 'http://geo.vassarlabs.com/geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    let l = this.getTNInundationCompGeoServerURLForecast() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (options.tnFilter) {
      l += '&cql_filter=' + options.tnFilter;
    }
    return this.http.get<any>(l);
  }
  geKWInnundationtGeoJSONData(layer, options) {
    // const layerURL = this.getInundationCompGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let url = ProjConstants.GEOSERVER_URL+'geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let l = 'http://geo.vassarlabs.com/geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    let l = this.getKWInundationCompGeoServerURLForecast() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (options.filter) {
      l += '&cql_filter=' + options.kwFilter;
    }
    return this.http.get<any>(l);
  }
  geODInnundationtGeoJSONData(layer, options) {
    // const layerURL = this.getInundationCompGeoServerURL() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let url = ProjConstants.GEOSERVER_URL+'geoserver/kaleshwaram/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    // let l = 'http://geo.vassarlabs.com/geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    let l = this.getODInundationCompGeoServerURLForecast() + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + layer + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (options.filter) {
      l += '&cql_filter=' + options.odFilter;
    }
    return this.http.get<any>(l);
  }

  stylingforGeoJson() {
    return {
      fillColor: '#99ccff',
      weight: 2,
      opacity: 1,
      color: '#0080ff',
      fillOpacity: 0.4
    };
  }

  getreservoirData() {
    const startEndList = this.getstartandEndForNday(5);
    const postData = {
      pEUUID:"00cb31c7-2928-4e6d-adcc-443d478c90d6",
      pUUID: "00cb31c7-2928-4e6d-adcc-443d478c90d6",
      pType: 'COUNTRY',
      cType: 'RESERVOIR',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'DAILY',
      sDate: startEndList[0],
      eDate: startEndList[1],
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };

  //   {
  //     "pEUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "pType": "COUNTRY",
  //     "cType": "RESERVOIR",
  //     "src": "STATE_AND_CENTRAL_STATIONS",
  //     "format": "DAILY",
  //     "sDate": "20230609",
  //     "eDate": "20230609",
  //     "classification": [
  //         "INSTANT_DATA"
  //     ],
  //     "aggr": "LATEST"
  // }
    const reservoirUrl = this.kaleshwaramWrisAPIUrl + 'reservoir/timeseries';
    return this.http.post<any>(reservoirUrl, postData);
  }


  getResPointData(sourceAlert:any){
    const startEndList = this.getstartandEndForNday(5);
    const postData = {
      pEUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pType: 'COUNTRY',
      cType: 'CATCHMENT_AREA',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'DAILY',
      sDate: startEndList[1],
      eDate: startEndList[1],
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST',
      rfSrc : sourceAlert ? sourceAlert : "IMD_RADAR_NOWCAST",
    };
    const reservoirUrl = this.kaleshwaramWrisAPIUrl + 'nowcast/resCatchment';
    return this.http.post<any>(reservoirUrl, postData);
  }

  getRainfallCatchmentData(sourceAlert:any){
    const startEndList = this.getstartandEndForNday(5);
    const postData = {
      pEUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      pType: 'COUNTRY',
      cType: 'CATCHMENT_AREA',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'DAILY',
      sDate: startEndList[0],
      eDate: startEndList[1],
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST',
      rfSrc : sourceAlert ? sourceAlert : "IMD_RADAR_NOWCAST",
    };
    // const reservoirUrl = this.kaleshwaramWrisAPIUrl + 'nowcast/nowcastTimeSeries';
    const reservoirUrl = this.kaleshwaramWrisAPIUrl + 'nowcast/catchmentNowcastTimeSeries';
    return this.http.post<any>(reservoirUrl, postData);

  }

  getriverGagugeData() {
    const startEndList = this.getstartandEndForNday(5);
    const postData = {
      pEUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pUUID: '9553a7af-56f8-495f-ba0c-c2d2324e6759',
      pType: 'COUNTRY',
      cType: 'RIVER_GAUGE',
      src: 'STATE_AND_CENTRAL_STATIONS',
      format: 'DAILY',
      sDate: startEndList[0],
      eDate: startEndList[1],
      classification: ['INSTANT_DATA'],
      aggr: 'LATEST'
    };
    const rivergaugeUrl = this.apiUrl + 'rivergauge/timeseries';
    return this.http.post<any>(rivergaugeUrl, postData);
  }

  getImageLayersForFloodForecast(type, basinName, metaData) {
    const layersList = metaData.FloodForecastCommonLayers;
    const imageList = this.ffUtilsService.getNDayListInFormat(null, 9, -2);
    const act = '_actual';
    imageList.sort();
    for (const key in layersList) {
      if (layersList.hasOwnProperty(key)) {
        const value = layersList[key];
        if (value.type === 'HEATMAP') {
          if (value.layeroptions_name == 'rf1') {
            value.layeroptions_name = imageList[2];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[2]);
          }
          if (value.layeroptions_name == 'rf2') {
            value.layeroptions_name = imageList[3];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[3]);
          }
          if (value.layeroptions_name == 'rf3') {
            value.layeroptions_name = imageList[4];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[4]);
          }
          if (value.layeroptions_name == 'rf4') {
            value.layeroptions_name = imageList[5];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[5]);
          }
          if (value.layeroptions_name == 'rf5') {
            value.layeroptions_name = imageList[6];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[6]);
          }
          if (value.layeroptions_name == 'rf6') {
            value.layeroptions_name = imageList[7];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[7]);
          }
          if (value.layeroptions_name == 'rf7') {
            value.layeroptions_name = imageList[8];
            value.name = this.ffUtilsService.getReadableDateFromDateString(imageList[8]);
          }
          if (value.layeroptions_name == 'three_day_cumulative') {
            value.layeroptions_name = 'three_day_cumulative';
            value.name = 'Next 3 days Cummulative';
            // dateUtils.getReadableDateFromDateString(imageList[6]);
          }
          if (value.layeroptions_name == 'sensor_data') {
            value.layeroptions_name = 'sensor_data';
            value.name = 'Rainfall Actual';
            // dateUtils.getReadableDateFromDateString(imageList[6]);
          }

          // if(value.layeroptions_name == "last_three_day_cumulative"){
          //   value.layeroptions_name = "last_three_day_cumulative";
          //   value.name = "Last 3 days Cummulative";
          //   // dateUtils.getReadableDateFromDateString(imageList[6]);
          // }
        }
      }
    }

    if (imageList) {
      return () => {
        return new Promise((resolve, reject) => {
          if (imageList.length > 0) {
            this.getFloodForecastHeatMaps(basinName).subscribe(data => {
              // get(imageList,function(data){
              resolve(this.createImageLayersForFloodForecast(data, layersList, basinName));
            });
          } else {
            resolve(this.createImageLayersForFloodForecast({}, layersList, basinName));
          }

        });
      };
    }
  }

  createImageLayersForFloodForecast(imageData, layersList, basinName) {
    const overlays = {};
    for (const key in layersList) {
      if (layersList.hasOwnProperty(key)) {
        const value = layersList[key];
        const overlay: any = {};
        overlay.name = value.name;
        overlay.type = 'image';
        overlay.layerOptions = {};
        overlay.layerOptions.name = value.name;
        overlay.bounds = this.getBoundsForType(basinName);
        if (this.validateValue(value.group_type)) {
          overlay.layerOptions.groupType = value.group_type;
        }
        if (this.validateValue(value.legendData)) {
          overlay.layerOptions.legendData = value.legendData;
        }
        if (this.validateValue(value.subgroup)) {
          overlay.layerOptions.subgroup = value.subgroup;
        }
        if (this.validateValue(value.visible)) {
          overlay.layerOptions.visible = value.visible;
        }
        if (this.validateValue(value.group)) {
          overlay.layerOptions.group = value.group;
        }
        if (this.validateValue(value.layeroptions_name)) {
          overlay.layerOptions.layerName = value.layeroptions_name;
        }
        if (this.validateValue(value.layeroptions_pane)) {
          //  overlay.layerOptions.pane = value.layeroptions_pane;
        }
        if (this.validateValue(value.layeroptions_min_zoom)) {
          overlay.layerOptions.minZoom = value.layeroptions_min_zoom;
        }
        if (this.validateValue(value.layeroptions_max_zoom)) {
          overlay.layerOptions.maxZoom = value.layeroptions_max_zoom;
        }
        if (this.validateValue(value.layeroptions_show_on_selector) && !value.layeroptions_show_on_selector) {
          overlay.layerOptions.showOnSelector = value.layeroptions_show_on_selector;
        }
        if (value.type === 'HEATMAP' && !this.validateValue(value.image_path)) {
          overlay.url = imageData[value.layeroptions_name];
          overlays[key] = overlay;
        } else if (value.type === 'HEATMAP' && this.validateValue(value.image_path)) {
          overlay.url = value.image_path;
          overlays[key] = overlay;
        }
        if (this.validateValue(value.info)) {
          overlay.layerOptions.info = value.info;
        }
      }
    }

    return overlays;
  }

  getBoundsForType(basinName) {
    const obj = {
      southzone: [[12.6237261107919, 73.341298312], [22.6909541480001, 84.7646464149238]],
      krishna: [[13.067985534668, 73.3019409179688], [19.441385269165, 81.2508850097656]],
      godavari: [[16.2708187103271, 73.42724609375], [22.7228946685791, 83.2075271606445]],
      ap: [[12.60004, 76.75599], [19.15689, 84.76102]],
      tsgodavari: [[15.8331755253303, 73.4756625663744], [22.6909542579327, 83.1591057924984]],
    };
    return obj[basinName];
  }

  setImageLayers(mapObject, imageLayers) {
    const layers = {};
    for (const key in imageLayers) {
      if (imageLayers.hasOwnProperty(key)) {
        const layer = imageLayers[key];
        if (typeof layer.url !== 'undefined') {
          let imageLayer = L.imageOverlay(layer.url, layer.bounds, layer.layerOptions);
          layers[key] = imageLayer;

          // if (this.urlParams.applyFilter === 'true' && layer.layerOptions.visible === true) {
          if (layer.layerOptions.visible === true) {
            layer.layerOptions.visible = false;
            imageLayer = L.imageOverlay(layer.url, layer.bounds, layer.layerOptions);
            layers[key] = imageLayer;
          } else if (layer.layerOptions.visible === true) {
            imageLayer.addTo(mapObject);
          }
        }
      }
    }
    return layers;
  }

  getActualHeatMapForFloodForecast(type, basinView) {
    const newlayerList = {};
    const promise1 = new Promise((resolve, reject) => {
      const dateList = this.ffUtilsService.getActualHeatMapDateList();
      let count = 0;
      for (const index in dateList) {
        if (index) {
          const dayType = index;
          const layer = {};
          const startDate = dateList[index][0];
          const endDate = dateList[index][1];
          const timeStep = 'DAILY';
          let pUUID;
          let pEUUID;
          let parentName;
          let basinName;
          let pType;
          if (basinView == 'godavariNew') {
            parentName = 'GODAVARI-BASIN';
            pUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
            pEUUID = '5ddb60ef-aede-46ab-b319-e8e9c36fd715';
            pType = 'BASIN';
            basinName = 'godavari';
          } else if (basinView == 'southzone') {
            parentName = 'SOUTHZONE_FLOW_NETWORK';
            pUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
            pEUUID = '3a7a18ff-8614-4c90-aa98-451b333df3d9';
            pType = 'REGION';
            basinName = 'southzone';
          } else if (basinView == 'godavariTelangana') {
            parentName = 'GODAVARI-TELANGANA';
            pUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
            pEUUID = 'a9a6494f-eaf0-44ca-a2d9-b8f2aad20fc1';
            pType = 'REGION';
            basinName = 'godavariTelangana';
          }
          const postData = {
            pUUID,
            pType,
            cType: 'BLOCK',
            format: 'DAILY',
            src: 'STATE_AND_CENTRAL_STATIONS',
            view: 'ADMIN',
            sDate: startDate,
            eDate: endDate,
            aggr: 'SUM',
            pEUUID: pUUID,
            classification: ['ACTUAL']
          };

          this.getBlockWiseRainfallHeatMap(postData).subscribe(data => {
            layer['url'] = data.ACTUAL;
            layer['name'] = dayType;
            layer['basinName'] = basinName;
            newlayerList[dayType] = layer;
            count++;
            if (Object.keys(dateList).length == count) {
              resolve(newlayerList);
            }
          });
        }
      }
    });
    return new Promise((resolve, reject) => {
      promise1.then((value) => {
        resolve(this.createRFActualHeatMap(value, null));
      });
    });
  }

  getRainfallActualAndForecastHeatMapsFromApwrims(otherOptions) {
    return new Promise((resolve, reject) => {
      const [dates, actualDateList, forecastDateList, currDate] = this.ffUtilsService.getDatesForRainfallActualAndForecastHeatMapsFromApwrims();
      // console.log(dates);
      this.getRainfallHeatMapDataFromApwrims(dates).subscribe(data => {
        const layerlist = {};
        let last_three = data['last_three_day_cumulative'];
        let next_three = data['three_day_cumulative'];
        const legendData = Object.assign({}, otherOptions['metaData'].RainfallLegend.LOW.legendData);
        legendData['title'] = 'Rainfall Level';
        const bounds = {
          y_min: 12.6237261107919,
          x_min: 73.341298312,
          y_max: 22.6909541480001,
          x_max: 84.7646464149238
        };
        const ForecastBounds = {
          y_min: 4.96,
          x_min: 64.96,
          y_max: 40.04,
          x_max: 100.04
        };
        if (last_three) {
          layerlist['Last 3 days Cumulative'] = {
            url: last_three,
            legendData,
            name: 'Rainfall Actual',
            group: 'Rainfall Actual',
            bounds
          };
        }

        if (next_three) {
          layerlist['Next 3 days Cumulative'] = {
            url: next_three,
            legendData,
            name: 'Rainfall Forecast',
            group: 'Rainfall Forecast',
            bounds
          };
        }

        for (const index in actualDateList) {
          const actualDate = actualDateList[index].value;
          const displayName = actualDateList[index].displayName;
          if (!data[actualDate + '_actual']) { continue; }
          layerlist[actualDate == currDate ? 'Today' : displayName] = {
            url: data[actualDate + '_actual'],
            legendData,
            name: 'Rainfall Actual',
            group: 'Rainfall Actual',
            bounds
          };
        }

        for (const index in forecastDateList) {
          const forecastDate = forecastDateList[index].value;
          const displayName = forecastDateList[index].displayName;
          if (!data[forecastDate]) { continue; }
          layerlist[displayName] = {
            url: data[forecastDate],
            legendData,
            name: 'Rainfall Forecast',
            group: 'Rainfall Forecast',
            bounds:ForecastBounds
          };
        }
        resolve(this.createCroppedImageLayers(layerlist));
      });
    });
  }

  createCroppedImageLayers(layerlist) {
    const overlays = {};
    for (const element in layerlist) {
      if (layerlist[element]) {
        const value = layerlist[element];
        const overlay: any = {};
        overlay.name = value['name'];
        overlay.type = 'HEATMAP';
        overlay.layerOptions = {};
        overlay.layerOptions.type = 'HEATMAP';
        overlay.layerOptions.name = element;
        overlay.layerOptions.displayName = element;
        overlay.bounds = value.bounds;
        overlay.layerOptions.group = value.group;
        overlay.url = value['url'];
        overlays[element] = overlay;
        overlay.layerOptions.visible = false;
        overlay.layerOptions.groupType = 'radio-deselect';
        overlay.layeroptions_min_zoom = 6;
        overlay.layeroptions_max_zoom = 18;
        overlay.layeroptions_show_on_selector = true;
        if (value.legendData) {
          overlay.layerOptions.legendData = value.legendData;
        }
        // overlay.layerOptions.pane = 'group1'
      }
    }
    return overlays;
  }

  setCroppedImageLayers(imageLayers, mapObject, filterOptions, regionSelected) {
    return new Promise(async (resolve, reject) => {
      const layers = {};
      for (const key in imageLayers) {
        if (imageLayers.hasOwnProperty(key)) {
          const layer = imageLayers[key];
          if (typeof layer.url !== 'undefined') {
            const bounds = layer.bounds;
            const anchors = [[bounds.y_max, bounds.x_min], [bounds.y_max, bounds.x_max],
            [bounds.y_min, bounds.x_max], [bounds.y_min, bounds.x_min]];
            const shpBoundaryData = await this.getShapeBoundaryLayersForRegions(filterOptions, regionSelected);
            // console.log(shpBoundaryData);
            if (shpBoundaryData != null) {
              layer.layerOptions['clip'] = shpBoundaryData;
            }
            const imageLayer = L.imageTransform(layer.url, anchors, layer.layerOptions);
            layers[key] = imageLayer;
            imageLayer.addTo(mapObject);
            mapObject.removeLayer(imageLayer);
            if (layer.layerOptions.visible === true) {
              imageLayer.addTo(mapObject);
            }
          }
        }
      }
      resolve(layers);
    });
  }

  createRFActualHeatMap(layerlist, legendData) {
    const overlays = {};
    for (const element in layerlist) {
      if (element) {
        const value = layerlist[element];
        const overlay: any = {};
        overlay.name = 'Rainfall Actual';
        overlay.type = 'HEATMAP';
        overlay.layerOptions = {};
        overlay.layerOptions.name = element;
        overlay.layerOptions.displayName = element;
        overlay.bounds = this.getBlockBoundsForType(value['basinName']);
        overlay.layerOptions.group = 'Rainfall Actual';
        overlay.url = value['url'];
        overlays[element] = overlay;
        overlay.layerOptions.visible = false;
        overlay.layerOptions.groupType = 'radio-deselect';
        overlay.layeroptions_min_zoom = 6;
        overlay.layeroptions_max_zoom = 18;
        overlay.layeroptions_show_on_selector = true;
        overlay.layerOptions.legendData = {
          title: 'Rainfall Actual',
          levels: [
            { color: '#FFFFFF', name: '0.0-0.2' },
            { color: '#FFFF9E', name: '0.2-2.4' },
            { color: '#FCF417', name: '2.4-15.5' },
            { color: '#45B6FE', name: '15.5-64.5' },
            { color: '#006B3C', name: '64.5-115.5' },
            { color: '#FF0000', name: '115.5-204.5' },
            { color: '#663300', name: '>= 204.5' },
          ]
        };
        // overlay.layerOptions.pane = 'group1'
      }
    }
    return overlays;
  }

  getBlockBoundsForType(basinName) {
    const obj = {
      southzone: [[11.61, 72.641298312], [23.5909541480001, 85.3646464149238]],
      godavari: [[14.305, 72.898], [24.51, 83.635]],
      godavariTelangana: [[14.105, 72.898], [24.33, 83.635]],
    };
    return obj[basinName];
  }


  getGeoServerURL() {
    // const url = environment.url.AP_GEOSERVER_URL + 'ows';
    const url = environment.url.GEOSERVER_URL + 'new-geoserver/' + 'ows';
    return url;
  }
  getTNGeoServerURL() {
    const url = environment.url.TNOD_GEOSERVER_URL + 'tamilnadu/ows';
    return url;
  }
  getKWGeoServerURL() {
    const url = environment.url.GEOSERVER_URL + 'new-geoserver/ows';
    return url;
  }
  getODGeoServerURL() {
    const url = environment.url.TNOD_GEOSERVER_URL + 'odisha/ows';
    return url;
  }

  getGeoServerForecastWMSURL() {
    const url = MapConstants.GEOSERVER_WMS_URL;
    return url;
  }

  getInundationCompGeoServerURL() {
    const url = ProjConstants.GEOSERVER_URL+'geoserver/kaleshwaram';
    return url;
  }

  getInundationCompGeoServerURLForecast() {
    const url = ProjConstants.GEOSERVER_URL+'new-geoserver/HEATWAVE/ows';
    return url;
  }
  getTNInundationCompGeoServerURLForecast() {
    const url = ProjConstants.TNGEOSERVER_URL+'geoserver/tamilnadu/ows';
    return url;
  }
  getKWInundationCompGeoServerURLForecast() {
    const url = ProjConstants.KLGEOSERVER_URL+'geoserver/KWRIS/ows';
    return url;
  }
  getODInundationCompGeoServerURLForecast() {
    const url = ProjConstants.ODGEOSERVER_URL+'geoserver/odisha/ows';
    return url;
  }

  getBasinDailyTableData() {
    return this.http.get<any>(this.apwrimsAPIUrl + 'flowmanagement/maxdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/hourLimit/0/24');
  }
  getTNRiverColorData(time) {
    return this.http.get<any>(this.tnwrimsUrl + 'glofas/1fab4ac3-af6f-4ba6-ac78-ebe18fe0ea2d/hms_combined/'+time+'/'+time);
  }
  getKERiverColorData(time) {
    return this.http.get<any>(this.kwrisURL + 'glofas/aff0f188-179a-460b-99a0-1421959dd2b5/hms_combined/'+time+'/'+time);
  }
  getODMahanadiRiverColorData(time) {
    return this.http.get<any>(this.odwrisURL + 'glofas/b56cbed6-209a-4c86-86c0-9dfd1ff32072/hms_combined/'+time+'/'+time);
  }
  getODBaitaraniRiverColorData(time) {
    return this.http.get<any>(this.odwrisURL + 'glofas/fe89ed3f-070a-4496-a115-49d92b870086/hms_combined/'+time+'/'+time);
  }
  getODBhramaniRiverColorData(time) {
    return this.http.get<any>(this.odwrisURL + 'glofas/8edead7c-4cfa-4f46-8deb-6b6616b2163b/hms_combined/'+time+'/'+time);
  }
  getODRushikulyaRiverColorData(time) {
    return this.http.get<any>(this.odwrisURL + 'glofas/51b464fd-0d8c-47b8-bb4c-16f4b133cf78/hms_combined/'+time+'/'+time);
  }

  getBasinPreviousDayTableData() {
    return this.http.get<any>(this.kaleshwaramStagingUrl + 'flowmanagement/tabledata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY');
  }

  getMetaDataForAllPoints() {
    return this.http.get<any>(this.apiUrl + 'nowcast/getReservoirDetail/00cb31c7-2928-4e6d-adcc-443d478c90d6');
  }
  // getMetaDataForAllPoints() {
  //   return this.http.get<any>(this.kaleshwaramStagingUrl + 'flowmanagement/masterdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9');
  // }

  getHecHmsMetaDataForAllPoints() {
    return this.http.get<any>(this.apiUrl + 'nowcast/getReservoirDetail/00cb31c7-2928-4e6d-adcc-443d478c90d6');
  }
  // getHecHmsMetaDataForAllPoints() {
  //   return this.http.get<any>(ProjConstants.FORECAST_KALESHWARAM_STAGING_API_URL + "flowmanagement/masterdata/root/a466f6ac-f810-451a-8d4c-e48961c714c9");
  // }

  getBasinTableDataNew(interval) {
    // return this.http.get<any>(this.kaleshwaramStagingUrl + 'flowmanagement/maxdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/hourLimit/' + interval);
  }

  getLatestKnownTableData() {
    return this.http.get<any>(this.kaleshwaramStagingUrl + 'flowmanagement/realtime/root/3a7a18ff-8614-4c90-aa98-451b333df3d9');
  }

  getReservoirMetaData(basin) {
    return this.http.get<any>(this.kaleshwaramStagingUrl + 'basinflowmetadata/' + basin);
  }

  getFloodForecastHeatMaps(basinName) {
    // return this.http.get<any>('http://kaleshwaram-staging.vassarlabs.com/api/flowmanagement/Kaleshwaramforecastheatmap/' + basinName);
    return this.http.get<any>(this.apwrimsAPIUrl + 'flowmanagement/Kaleshwaramforecastheatmap/' + basinName);
  }

  getBlockWiseRainfallHeatMap(options: object) {
    const heatMapURL = this.kaleshwaramWrisAPIUrl + 'rf/heatmap';
    return this.http.post<any>(heatMapURL, options);
  }

  getRainfallDataforthisRegion(options: object) {
    const sensorDataURL = this.kaleshwaramWrisAPIUrl + 'rf/aggregated';
    return this.http.post<any>(sensorDataURL, options);
  }

  getRainfallHeatMapDataFromApwrims(dateList: object) {
    const dates = {};
    for (const index in dateList) {
      dates[index] = dateList[index];
    }
    const options = {
      params: dates,
    };
    const heatMapUrl = ProjConstants.API_URL + 'flowmanagement/forecastheatmaps/southzone';
    return this.http.get<any>(heatMapUrl, options);
  }
}
